import React from "react";
import * as tmscall from "../common/restService/tmServices";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Window } from "@progress/kendo-react-dialogs";
import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";
import * as ServiceCall from "../common/restService/tmServices";
import "../IntelShipmentRequest/intelShip.css";
import { process } from "@progress/kendo-data-query";
import { count } from "@progress/kendo-data-query/dist/npm/array.operators";
import "../commonStyle/tmsStyle.scss";
//import dm from '../IntelShipmentRequest/demo.jsx';
import { filterBy } from "@progress/kendo-data-query";
import $, { event } from "jquery";
import { filter } from "@progress/kendo-data-query/dist/npm/transducers";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import StatusHistorys from "../StatusHistory/StatusHistory";
import ItemDetail from "../IntelShipmentRequest/itemdetail";
import back from "../images/back-button.png";
import InvoiceBidDetails from "../InvoiceBidDetails/InvoiceBidDetails";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import TenderingManager from "../TenderingManager/tenderingMgr";
import qs from "qs";
import kendo from '@progress/kendo-ui';
import { withRouter } from "../NCRMSHome/withRouter";
import Loaders from '../Loaders';
import BlockUi from '@availity/block-ui';

//const newdate=new Date();
//this.reasonitem={text:'select Reason Code'};

// const RequestPickupDateDefaultValue = new Date();
const RequestPickupDateDefaultValue = new Date(2000, 2, 10, 13, 30, 0);

class IntelShipRequest extends React.Component {
  constructor(props) {
    super(props);

    var ReqPickupDate = new Date();
    var ReqDeliveryDate = new Date();
    this.itemdetail = this.itemdetail.bind(this);

    this.reasonitem = { text: "Select Reason Code" };

    this.svcitm = { text: "Select Service Code" };
    this.parentscac = { text: "Select Parent SCAC" };
    this.comitm = { text: "Select Commodity Code" };
    this.tramitm = { text: "Select Transportation Mode" };
    this.frmcnt = { text: "Select Country" };
    this.frmregion = { text: "Select Region" };
    this.frmport = { text: "Select Port" };
    this.inconitm = { text: "Select Incoterms" };
    this.ddmentitm = { text: "Select Doc Type" };
    this.RequestPickupDateDefaultValue = new Date(2000, 2, 10, 13, 30, 0);
    this.state = {
      //GetResponseValue: this.props.location.state,
      /***********Form Disable*************** */
      //isNew:true,
      warningMsg: "",
      docTypeStatus: false,
      HeaderCreateByUser: null,
      AutzCarrier: false,
      savebtnDisabled: false,
      EditbtnDisabled: false,
      CancelbtnDisabled: false,
      FOCancelcontent: false,
      ToPortLocationTimeZone: null,
      DateChanged: "",
      portLocationArea: null,
      PortLocationTimeZone: null,
      orgcontent: false,
      docDisabled: false,
      FO_status: "",
      docLineType: "",
      tobeauthorValue: null,
      ShipFromTimeZone: null,
      ShipToTimeZone: null,
      USER_TIMEZONE: null,
      blocking: true,
      abbrDisabled: false,
      scacDisabled: false,
      delivery_disabled: false,
      frmPort_disabled: false,
      frmzipCode_disabled: false,
      reasonDisabled: false,
      ncrmcomtDisabled: false,
      Req_phone_disabled: false,
      segment_disabled: false,
      authorize_disabled: false,
      comp_name_disabled: false,
      Frmaddress_disabled: false,
      frmCity_disabled: false,
      cntry_Disabled: false,
      frmRegion_disabled: false,
      zipCode_disabled: false,
      cntname_disabled: false,
      frmPhone_disabled: false,
      frmemail_disabled: false,
      Tocompname_disabled: false,
      Toaddline_disabled: false,
      toCity_disabled: false,
      Tocntry_disabled: false,
      Toregion_disabled: false,
      toPort_disabled: false,
      toZip_disabled: false,
      Tocont_disabled: false,
      Tophone_disabled: false,
      toEmail_disabled: false,
      Toadd_disabled: false,
      pickup_disabled: false,
      broker_disabled: false,
      contName_disabled: false,
      phone_disabled: false,
      broker_disabled: false,
      service_disabled: false,
      comm_disabled: false,
      transport_disabled: false,
      tpt_disabled: false,
      inconterms_disabled: false,
      location_disabled: false,
      intelrefer_disabled: false,
      doctype_disabled: false,
      specialInst_disabled: false,
      tor_key: "",
      HawbNumber: "",
      ProNumber: "",
      Req: "",
      scacVisible: true,
      abbvalue: null,
      FO_Display_Item: [],
      requseremail: false,
      requsername: false,
      toLocat: false,
      tobdloc: false,
      frmlocation: false,
      frmbdloc: false,
      specialinstruct: null,
      FromShipEmailId: null,
      TocityValue: null,
      tptValue: null,
      Shiplocationvalue: null,
      intelrefnum: null,
      brokeremailvalue: null,
      brokerPhonenumbervalue: null,
      brokerNameValue: null,
      brokerValue: null,
      ToBpIdValue: null,
      ToContactName: null,
      ToPhoneNumber: null,
      ToEmail: null,
      toAdd_info: null,
      ToLocationId: null,
      ToCompanyname: null,
      ToAddressline: null,
      ToZipvalue: null,
      FrombpID: null,
      FromContactName: null,
      FromShipPhone: null,
      FromadditionInfo: null,
      FromZipCode: null,
      shipFromCityValue: null,
      shipfromAddressValue: null,
      ShipFromcompName: null,
      ShipFromLocat: null,
      ncrmcommentvalue: null,
      ResPhonenumber: null,
      ncrmcommentvalue: null,
      //ShipFromhouseStreet: null
      //To_housestreet: null,
      // SegmentValue: { text: "Select Segment" },
      CommodityData: [],
      TransportationData: [],
      DocumentTypeData: [],
      ServiceCodeData: [],
      incoTermsData: [],
      ToPortData: [],
      CommodityValue: { text: "Select Commodity Code" },
      TransportationValue: { text: "Select Transportation Mode" },
      ServiceCodeValue: { text: "Select Service Code" },
      incotermValue: { text: "Select Incoterms" },
      ReqPickupDate: "",
      ReqDeliveryDate: "",
      documentVersion: 0,
      ToRegionValue: { text: "Select Region" },
      ToRegionData: [],
      ToFilterRegionData: [],
      filterRegionData:[],
      ToportValue: { text: "Select Port" },
      DocTypeValue: { text: "Select Doc Type" },
      toCountryValue: { text: "Select Country" },
      filterCountryList: [],
      authorization: [],
      disabled: false,
      documentData: [],
      myDate: "",
      // docValue: { FOType: "ZSSB", text: "Intel Shipment Request" },
      docValue: { text: "Select Document Type" },
      BindParentCode: [],
      BindReasonCode: [],
      reasoncodeValue: { text: "Select Reason Code" },
      ParentScacCode: { text: "Select Parent SCAC" },
      planningOrg: { value: "GLO - Global Logistic Organization" },
      userID: [],
      userEmail: [],
      logginuserId: [],
      FromcountryList: [],
      FromCountryValue: { text: "Select Country" },
      fromRegionValue: { text: "Select Region" },
      FromPortValue: { text: "Select Port" },
      comp_region: [],
      FromRegionData: [],
      FromPortData: [],
      tor_id: sessionStorage.getItem("tor_id"),
      Tor_idnum: "",
      DOCSTATUSForProp: null,
      vendor_id: null,
      currentTab: null,
      isNew: false,
      Tor_Type:null,
      isBidHiden:false,
      //  new code
      isBidSaved: false,
      isEditClicked: false,
      invoiceDetailInputsOnSubmit: null,
      // code added 
      error_select_doc_type: false,
      copyTabRefresh: false,
      editTabRefresh: false,
      STATUS:"",
      EX_NOTES:""
    };

    this.baseState = this.state;
    this.tenderingManagerRef = React.createRef();
    this.itemDetailsRef = React.createRef();

    // code added
        
    

    // this.FO_SaveData=this.FO_SaveData.bind(this);
    // this.FO_ClearData = this.FO_ClearData.bind(this);
  }

  backClick() {
    if (this.props.location.state.authData != undefined)
    {
      this.props.navigate("/ncrmauthorization");
    }
    else if (this.props.location.state.searchScreenData != undefined)
    {
      this.props.navigate("/FrightOrderSearch");
    }
    else if (this.props.location.state.approvalData != undefined)
    {
      this.props.navigate("/Approver");
    }
    
    else if (this.props.location.state.FGsearchScreenData != undefined)
    {
      this.props.navigate("/FGSearch");
    }
    else
    {
      this.props.navigate("/NCRMHome");
    }
  }

  componentDidMount() {
    //  If the user redirects from email links
    // Parse the url and get tor_key and fo type and do api call
    const tor_key = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).torID;
    const FOType = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).FOType;
    var fgTORStatus = "";

    if (typeof tor_key !== "undefined" && typeof FOType !== "undefined") {
      let tor_type = null;
      if (FOType === "SingleBid") {
        tor_type = "ZSSB";
      } else if (FOType === "MultiBid") {
        tor_type = "ZEXC";
      } else if (FOType === "InvAdj") {
        tor_type = "ZMSB";
      }
      this.setState({ tor_key: tor_key, Tor_Type: tor_type });
      this.Fo_display_data(tor_key, "ZSSB", "emailLink");
    }
    this.setState({ blocking: true });
    if (this.props.location.state.isFGType != undefined) {
      const FGNCRM = this.props.location.state.isFGType;
      this.setState({ FGType: FGNCRM });
    } else {
       this.setState({ FGType: false });
    }

    let tor_id = "";
    if (this.props.location.state.authData != undefined) {
      tor_id = this.props.location.state.authData.freightOrder;
      this.state.tor_id = tor_id;
     this.setState({ tor_id: tor_id });
     sessionStorage.setItem("tor_id",tor_id);
      if (this.props.location.state.authData.docTypeDesc == "Intel Shipment Request")
       this.state.Tor_Type = "ZSSB";

      if (
        this.props.location.state.authData.docTypeDesc == "Invoice Adjustment Request"
      )
       this.state.Tor_Type = "ZEXC";
      if (this.props.location.state.authData.docTypeDesc == "Multi-Bid Request")
        this.state.Tor_Type = "ZMSB";
      if (this.state.Tor_Type == "ZEXC") this.setState({ isBidHiden: true });
      localStorage.setItem("tor_type", this.state.Tor_Type);
    } else if (this.props.location.state.searchScreenData != undefined) {
      tor_id = this.props.location.state.searchScreenData.FO_NUMBER;
      this.state.tor_id = tor_id;
     this.setState({ tor_id: tor_id });

      sessionStorage.setItem("tor_id", tor_id);
      if (
        this.props.location.state.searchScreenData.DOC_TYPE ==
        "Intel Shipment Request"
      )
        this.state.Tor_Type = "ZSSB";
      if (
        this.props.location.state.searchScreenData.DOC_TYPE ==
        "Invoice Adjustment Request"
      )
      {
        this.state.Tor_Type = "ZEXC";        
      }
      if (this.props.location.state.searchScreenData.DOC_TYPE == "Multi-Bid Request")
        this.state.Tor_Type = "ZMSB";
      if (
        this.props.location.state.searchScreenData.DOC_TYPE ==
        "Invoice Adjustment Request"
      )
        this.setState({ isBidHiden: true });
      localStorage.setItem("tor_type", this.state.Tor_Type);
    } else if (this.props.location.state.FGsearchScreenData != undefined) {
      fgTORStatus = this.props.location.state.FGsearchScreenData.YTOR_DOCSTATUS;

      tor_id = this.props.location.state.FGsearchScreenData.NCRM_REQ;
      this.setState({ tor_id: tor_id });
      sessionStorage.setItem("tor_id", tor_id);
      if (
        this.props.location.state.FGsearchScreenData.NCRM_REQ_TYPE ==
        "Intel Shipment Request"
      )
        this.state.Tor_Type = "ZSSB";
      if (
        this.props.location.state.FGsearchScreenData.NCRM_REQ_TYPE ==
        "Invoice Adjustment Request"
      )
        this.state.Tor_Type = "ZEXC";
      if (
        this.props.location.state.FGsearchScreenData.NCRM_REQ_TYPE ==
        "Multi-Bid Request"
      )
       this.state.Tor_Type = "ZMSB";
      if (
        this.props.location.state.FGsearchScreenData.NCRM_REQ_TYPE ==
        "Invoice Adjustment Request"
      )
        this.setState({ isBidHiden: true });
      localStorage.setItem("tor_type", this.state.Tor_Type);
    } else if (this.props.location.state.approvalData != undefined) {
      tor_id = this.props.location.state.approvalData.freightOrder;
      this.setState({ tor_id: tor_id });
      //this.state.tor_id = tor_id;
      sessionStorage.setItem("tor_id", tor_id);
      if (
        this.props.location.state.approvalData.docTypeDesc == "Intel Shipment Request"
      )
       this.state.Tor_Type = "ZSSB";
      if (
        this.props.location.state.approvalData.docTypeDesc ==
        "Invoice Adjustment Request"
      )
       this.state.Tor_Type = "ZEXC";
      if (this.props.location.state.approvalData.docTypeDesc == "Multi-Bid Request")
       this.state.Tor_Type = "ZMSB";
      if (this.state.Tor_Type == "ZEXC") this.setState({ isBidHiden: true }); 
      localStorage.setItem("tor_type", this.state.Tor_Type);
    } else if (this.state.requestAuthorizedState != undefined) {
      if (
        this.state.requestAuthorizedState.isRequestAuthorized == true
      ) {
        tor_id = sessionStorage.getItem("tor_id");

        this.state.Tor_Type =
          this.state.requestAuthorizedState.tor_type;

        console.log("Tor type when redirected from request page");
      }
    } else {
      
      tor_id = sessionStorage.getItem("tor_id");
      if(this.props.location.state.TorType===null)
      {
      this.setState({ blocking: false });
      }
      if (this.props.location.state != undefined) {
        this.state.isNew = this.props.location.state.isNew;
        this.state.Tor_Type = this.props.location.state.TorType;
      } 
      else {
        this.setState({ isNew: false });
        this.setState({ Tor_Type: localStorage.getItem("tor_type") });
      }
      if (this.state.Tor_Type == "ZEXC") this.setState({ isBidHiden: true });
    }
    if (tor_id != null) {
      this.Fo_display_data(tor_id, this.state.Tor_Type);
      if (this.state.Tor_Type == "ZEXC") this.setState({ isBidHiden: true });
    }
    //Anitha's changes
    // this.setState({isNew : this.props.location.state})

    console.log("YORDOCSTATUS", this.state.Tor_Type);

    //  if(this.props.location.state==true){
    ;
    if (this.props.location.state.isNew == true) {
      $(
        "button.reset-disable,button.Edit-disable,button.copy-disable,button.can_disable"
      ).addClass("menu-disable");
      $("button.Save-disable").removeClass("menu-disable");
      $("a.Tab_status,a.Tab_inv,a.Tab_bid,a.Tab_item").addClass("menu-disable");
    } 
    else if (this.props.location.state.isFGType != undefined) {
      if (fgTORStatus === "SAVED")
        $("button.Save-disable").removeClass("menu-disable");
      else $("button.Save-disable").addClass("menu-disable");
    } 
    else {
      $(
        "a.Tab_status,button.reset-disable,button.can_disable,button.copy-disable"
      ).removeClass("menu-disable");
      $("button.Save-disable").addClass("menu-disable");
    }

    $("#doctval").show();
    $("a.Tab_item").addClass("menu-disable");
    this.setState({ Req: false, orgcontent: true });
    this.NcrmSearchView();
    this.loadDocType(this.state.Tor_Type);

    this.getDate();
    this.ReasonCode();
    this.ParentSCAC();
    // this.getSegmentData();
    this.F4_TO_BE_AUTHORIZED_BY();
    this.F4_COUNTRIES_REGIONS_V1();
    this.F4_INCOTERMS();
    this.F4_SERVICE_CODE();
    this.F4_DOCUMENT_TYPE();
    this.F4_TRANSPORTATION_MODE();
    this.F4_SERVICE_TYPE();
    this.getUserDetail();
    this.setState({
      requseremail: true,
      requsername: true,
      frmlocation: true,
      frmbdloc: true,
      toLocat: true,
      tobdloc: true,
    });
  }

  async Fo_display_data(tor_id, tor_Type, type = "new") {

    if (tor_Type === "ZMSB") {
      this.setState({ scacVisible: false });
    }
    this.setState({ blocking: true, displayClicked: true });
    // $("a.Tab_item").removeClass("menu-disable");
    this.setState({ Req: true, docVisible: true });
    let tor_idValue = tor_id;
    if (
      this.props.location.state.authData != undefined ||
      this.props.location.state.approvalData != undefined ||
      this.props.location.state.searchScreenData != undefined ||
      this.props.location.state.FGsearchScreenData != undefined
    )
      this.state.IntelShip_number = tor_id;
    else
      this.state.IntelShip_number =
        type !== "emailLink" ? tor_idValue.substr(10, 10) : "";
    let props = {};
    let inputObjs = {};
    let InputJSONString = "";
    if (type !== "emailLink") {
      InputJSONString = JSON.stringify({ tor_id: tor_idValue });
    } else {
      InputJSONString = JSON.stringify({ tor_key: tor_id });
    }
    //console.log("InputJSONString",InputJSONString);
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    if (tor_Type == "ZSSB") inputObjs["Activity"] = "FO_DISPLAY_SB";
    else if (tor_Type == "ZMSB") inputObjs["Activity"] = "FO_DISPLAY_MB";
    //
    else inputObjs["Activity"] = "FO_DISPLAY_INVA";
    inputObjs["Input"] = InputJSONString;
    props.input = inputObjs;

    const result = await GatewayGet(props, props.input);
    
    console.log("result FO------>", result);
    this.state.EX_ADDRESS = result["EX_ADDRESS"];
    this.state.EX_ATTRIBUTES = result["EX_ATTRIBUTES"];
    this.state.EX_BP = result["EX_BP"];
    this.state.EX_DOCREF = result["EX_DOCREF"];
    this.state.EX_HEADER = result["EX_HEADER"];
    this.state.EX_ITEM = result["EX_ITEM"];
    
    var DOCSTATUS = this.state.EX_HEADER.YTOR_DOCSTATUS;
    var notes = [];
    this.state.DOCSTATUSForProp=result["EX_HEADER"].YTOR_DOCSTATUS

    this.setState({
      DOCSTATUSForProp: result["EX_HEADER"].YTOR_DOCSTATUS
    });
    this.state.vendor_id=result["EX_HEADER"].TSPID
    this.setState({
      vendor_id: result["EX_HEADER"].TSPID,
    });

    this.setState({ EX_NOTES: result["EX_NOTES"] });
    //this.state.EX_NOTES = result["EX_NOTES"];
    this.setState({ STATUS: result["STATUS"] });
   // this.state.STATUS = result["STATUS"];
    if(result["EX_NOTES"]!== undefined){
    var notes = result["EX_NOTES"];
    for (var i = 0; i < notes.length; i++) {
      if (notes[i].TEXT_TYPE == "ZBRE") {
        this.state.brokeremailvalue = notes[i].TEXT;
        this.setState({ brokeremailvalue: notes[i].TEXT });
      } else if (notes[i].TEXT_TYPE == "ZBRN") {
        this.state.brokerNameValue = notes[i].TEXT;
        this.setState({ brokerNameValue: notes[i].TEXT });
      } else if (notes[i].TEXT_TYPE == "ZBRP") {
        this.state.brokerPhonenumbervalue = notes[i].TEXT;
        this.setState({ brokerPhonenumbervalue: notes[i].TEXT });
      } else if (notes[i].TEXT_TYPE == "ZNRC") {
        //NCRM CIP Changes.
        //  if(vm.isCopyFO)

        //             vm.comments = "";
        //else
        this.state.ncrmcommentvalue = notes[i].TEXT;
        if(this.state.ncrmcommentvalue !== undefined)
        if(this.state.ncrmcommentvalue.includes('FG FO#'))
        {
          this.state.FGType = true;
        }
        this.setState({ ncrmcommentvalue: notes[i].TEXT });
      } else if (notes[i].TEXT_TYPE == "ZSIR") {
        //NCRM CIP Changes.
        //if(vm.isCopyFO)
        //vm.SpecialInst = "";
        //else
        this.state.specialinstruct = notes[i].TEXT;
        this.setState({ specialinstruct: notes[i].TEXT });
      } else if (notes[i].TEXT_TYPE == "ZBRO") {
        this.state.brokerValue = notes[i].TEXT;
        this.setState({ brokerValue: notes[i].TEXT });
      } else if (notes[i].TEXT_TYPE == "ZREP") {
        this.state.ResPhonenumber = notes[i].TEXT;
        this.setState({ ResPhonenumber: notes[i].TEXT });
      } else if (notes[i].TEXT_TYPE == "ZSRC") {
       this.state.shipfromAddressValue = notes[i].TEXT;
        this.setState({ shipfromAddressValue: notes[i].TEXT });
      } else if (notes[i].TEXT_TYPE == "ZDES") {
        this.state.ToAddressline = notes[i].TEXT;
        this.setState({ ToAddressline: notes[i] });
      }
    }
  }
    sessionStorage.setItem("DOCSTATUS", DOCSTATUS);
    // When redirected from emailUrl link there will be no tor_id stored
    if (
      this.state.tor_id === null ||
      typeof this.state.tor_id === "undefined"
    ) {
      this.setState({ tor_id: result["EX_HEADER"]["TOR_ID"] });
      sessionStorage.setItem("tor_id", result["EX_HEADER"]["TOR_ID"]);
    }

    let createdByUser = this.state.EX_HEADER.CREATED_BY;

    this.setState({ HeaderCreateByUser: createdByUser });
    //if(this.state.EX_HEADER.CREATED_BY==this.state.logginuserId){
console.log(" debug first" + parseInt(DOCSTATUS))
    if (parseInt(DOCSTATUS) > 10) {
      this.setState({ EditbtnDisabled: true });
      
    } else {
      this.setState({ EditbtnDisabled: false });
    }
    if (this.state.roleList["BB"] == "True") {
      if (
        // this.state.EX_BP != "" ||
        this.state.EX_BP !== undefined 
        // ||
        // this.state.EX_BP != null
      ) {
        var DisplayAuthorList = [];
        for (var i = 0; i < this.state.EX_BP.length; i++) {
          if (this.state.EX_BP[i].PARTY_RCO == "TM201") {
            this.setState({ AutzCarrier: false });
            const AthList = this.GetAuthorList(this.state.EX_BP[i].PARTY_ID);
            DisplayAuthorList.push({
              idsid: this.state.EX_BP[i].PARTY_ID,
              name: AthList,
            });
          } else {
            this.setState({ AutzCarrier: true });
          }
        }

        this.state.tobeauthorValue = DisplayAuthorList;
      }
    }

    if (
      this.state.roleList["CARRIER"] == "True" ||
      this.state.roleList["CW"] == "True"
    ) {
      if (
        // this.state.EX_BP != "" ||
        this.state.EX_BP !== undefined 
        // ||
        // this.state.EX_BP != null
      ) {
      var DisplayAuthorList = [];
      for (var i = 0; i < this.state.EX_BP.length; i++) {
        if (this.state.EX_BP[i].PARTY_RCO == "TM201") {
          const AthList = this.GetAuthorList(this.state.EX_BP[i].PARTY_ID);
          DisplayAuthorList.push({
            idsid: this.state.EX_BP[i].PARTY_ID,
            name: AthList,
          });
        }
      }
    }

      this.state.tobeauthorValue = DisplayAuthorList;

      if (DOCSTATUS == "20") {
        $("button.Edit-disable").addClass("menu-disable");
      }
      if (DOCSTATUS == "60" || DOCSTATUS == "90") {
        $("button.copy-disable").removeClass("menu-disable");
        $(
          "button.can_disable,button.Save-disable,button.Edit-disable"
        ).addClass("menu-disable");
      }

      if (
        DOCSTATUS == "99" ||
        DOCSTATUS == "80" ||
        DOCSTATUS == "78" ||
        DOCSTATUS == "40" ||
        DOCSTATUS == "74"
      ) {
        $(
          "button.can_disable,button.Save-disable,button.Edit-disable"
        ).addClass("menu-disable");
        $("button.copy-disable").removeClass("menu-disable");
      }
      console.log(this.state.roleList["CW"])
      if (this.state.roleList["CW"] == "True") {
        $("a.Tab_bid,a.Tab_inv,a.Tab_status").hide();
      }

      if (
        DOCSTATUS == "20" ||
        DOCSTATUS == "30" ||
        DOCSTATUS == "45" ||
        DOCSTATUS == "55" ||
        DOCSTATUS == "35"
      ) {
        $("button.copy-disable,button.can_disable").removeClass("menu-disable");
        $("button.Save-disable,button.Edit-disable").addClass("menu-disable");
      }
    }

    //Home screen role based access
    else if (this.state.roleList["APPROVER"] == "True") {
      $(
        "button.submit-disable,button.Save-disable,button.copy-disable,button.can_disable,button.Edit-disable"
      ).addClass("menu-disable");
    } else if (this.state.roleList["CARRIER"] == "True") {
      if (DOCSTATUS == "40" || DOCSTATUS == "80") {
        $(
          "button.submit-disable,button.Save-disable,button.can_disable,button.Edit-disable"
        ).addClass("menu-disable");
        $("button.copy-disable").removeClass("menu-disable");
      }
    } else {
      // To Be Authorized Field have data only

      if (DOCSTATUS == "10") {
        if (this.state.FGType === false) {
          $("button.Save-disable").addClass("menu-disable");
        } else {
          $("button.Save-disable").removeClass("menu-disable");
        }
        $("button.copy-disable,button.can_disable").removeClass("menu-disable");

        // if(this.state.EX_HEADER.CREATED_BY==this.state.logginuserId){
        //   $("button.Edit-disable").removeClass('menu-disable');
        //  }else{
        //   $("button.Edit-disable").addClass('menu-disable');
        //  }
      }

      if (DOCSTATUS == "60" || DOCSTATUS == "90") {
        $("button.copy-disable").removeClass("menu-disable");
        $(
          "button.can_disable,button.Save-disable,button.Edit-disable"
        ).addClass("menu-disable");
      }

      if (
        DOCSTATUS == "99" ||
        DOCSTATUS == "80" ||
        DOCSTATUS == "78" ||
        DOCSTATUS == "40" ||
        DOCSTATUS == "74"
      ) {
        $(
          "button.copy-disable,button.can_disable,button.Save-disable,button.Edit-disable"
        ).addClass("menu-disable");
        $("button.copy-disable").removeClass("menu-disable");
      }

      //20 30 45 55 70
      if (
        DOCSTATUS == "20" ||
        DOCSTATUS == "30" ||
        DOCSTATUS == "45" ||
        DOCSTATUS == "55" ||
        DOCSTATUS == "35"
      ) {
        $("button.copy-disable,button.can_disable").removeClass("menu-disable");
        $("button.Save-disable,button.Edit-disable").addClass("menu-disable");

        // if(this.state.EX_HEADER.CREATED_BY==this.state.logginuserId){
        //   $("button.Edit-disable").removeClass('menu-disable');
        //  }else{
        //   $("button.Edit-disable").addClass('menu-disable');
        //  }
      }

      if (
        DOCSTATUS >= "70" &&
        DOCSTATUS != "90" &&
        DOCSTATUS != "80" &&
        DOCSTATUS != "40" &&
        DOCSTATUS != "78"
      ) {
        $("button.copy-disable").removeClass("menu-disable");
        $(
          "button.Save-disable,button.Edit-disable,button.can_disable"
        ).addClass("menu-disable");
      }

      //35 50 45 greater than 71

      if (DOCSTATUS == "35" || DOCSTATUS == "50" || DOCSTATUS == "45") {
        $("button.copy-disable").removeClass("menu-disable");
        $("button.can_disable,button.Save-disable").addClass("menu-disable");

        // if(this.state.EX_HEADER.CREATED_BY==this.state.logginuserId){
        //   $("button.Edit-disable").removeClass('menu-disable');
        //  }else{
        //   $("button.Edit-disable").addClass('menu-disable');
        //  }
      }
    }

    // Enable Invoice if docStatus is greater or === 70  and user is of type carrire
    if (this.state.roleList["CARRIER"] === "True") {
      $("button.can_disable").addClass("menu-disable");

      if (DOCSTATUS >= "70" && DOCSTATUS != "90") {
        $("button.copy-disable").removeClass("menu-disable");
        $(
          "button.Save-disable,button.Edit-disable,button.can_disable"
        ).addClass("menu-disable");
      }

      if (
        DOCSTATUS >= "70" ||
        (this.state.Tor_Type == "ZEXC" && DOCSTATUS >= "10")
      ) {
        $("a.Tab_inv").removeClass("menu-disable");
      } else {
        $("a.Tab_inv").addClass("menu-disable");
      }
    }

    // BB user greater 70
    if (this.state.roleList["BB"] === "True") {
      if (
        DOCSTATUS > "70" ||
        (this.state.Tor_Type == "ZEXC" && DOCSTATUS >= "10")
      ) {
        $("a.Tab_inv").removeClass("menu-disable");
      } else {
        $("a.Tab_inv").addClass("menu-disable");
      }
    }

    this.setState({
      ...this.state,
      FO_Display_Item: this.state.EX_ITEM,
      create_request: this.props.location.state,
    });
    //this.forceUpdate();

    this.setState({
      abbrDisabled: true,
      docDisabled: true,
      doctype_disabled: true,
      Toaddline_disabled: true,
      scacDisabled: true,
      delivery_disabled: true,
      frmPort_disabled: true,
      frmzipCode_disabled: true,
      reasonDisabled: true,
      ncrmcomtDisabled: true,
      segment_disabled: true,
      authorize_disabled: true,
      comp_name_disabled: true,
      Frmaddress_disabled: true,
      frmCity_disabled: true,
      cntry_Disabled: true,
      frmRegion_disabled: true,
      zipCode_disabled: true,
      cntname_disabled: true,
      frmPhone_disabled: true,
      frmemail_disabled: true,
      Tocompname_disabled: true,
      toCity_disabled: true,
      Tocntry_disabled: true,
      Toregion_disabled: true,
      toPort_disabled: true,
      toZip_disabled: true,
      Tocont_disabled: true,
      Tophone_disabled: true,
      toEmail_disabled: true,
      Toadd_disabled: true,
      pickup_disabled: true,
      broker_disabled: true,
      contName_disabled: true,
      phone_disabled: true,
      broker_disabled: true,
      service_disabled: true,
      comm_disabled: true,
      transport_disabled: true,
      tpt_disabled: true,
      inconterms_disabled: true,
      location_disabled: true,
      intelrefer_disabled: true,
      specialInst_disabled: true,
    });

    if (this.state.FGType === true) {
      this.setState({ Req_phone_disabled: false });
    } else {
      this.setState({ Req_phone_disabled: true });
    }
    if (result["EX_HEADER"].TOR_TYPE == "ZSSB") {

      var IntelRequest = result["EX_HEADER"].TOR_ID.substr(10, 10);
      this.setState({ docValue: { FOType: "ZSSB", text: "Intel Shipment Request" } });
      //console.log("this.state.docValue",this.state.docValue);
      this.setState({ bindtextAndId: IntelRequest });
    } else if (result["EX_HEADER"].TOR_TYPE == "ZMSB") {
      

      var IntelRequest = result["EX_HEADER"].TOR_ID.substr(10, 10);


      this.setState({ docValue: { FOType: "ZMSB", text: "Multi-Bid Request" } });

      this.setState({ bindtextAndId: IntelRequest });
    } else if (result["EX_HEADER"].TOR_TYPE == "ZEXC") {
      var IntelRequest = result["EX_HEADER"].TOR_ID.substr(10, 10);
      this.setState({ docValue: { FOType: "ZEXC", text: "Invoice Adjustment Request" } });
      this.setState({ bindtextAndId: IntelRequest });
    }

    var firstname = "",
      lastname = "";

    if (this.state.EX_ATTRIBUTES != undefined){
    for (var i = 0; i < this.state.EX_ATTRIBUTES.length; i++) {
      if (this.state.EX_ATTRIBUTES[i].NAME == "EMAIL_ID") {
        var descParts = this.state.EX_ATTRIBUTES[i].VALUE;
        this.setState({ userEmail: descParts });
      }

      if (this.state.EX_ATTRIBUTES[i].NAME == "PHONE_NUMBER") {
        var Phonenum = this.state.EX_ATTRIBUTES[i].VALUE;
        // this.setState({ ResPhonenumber: Phonenum });
      }

      if (this.state.EX_ATTRIBUTES[i].NAME == "FIRST_NAME") {
        firstname = this.state.EX_ATTRIBUTES[i].VALUE;
        //this.setState({ResPhonenumber:Phonenum});
      }

      if (this.state.EX_ATTRIBUTES[i].NAME == "LAST_NAME") {
        lastname = this.state.EX_ATTRIBUTES[i].VALUE;
      }
      var fullname = firstname + " " + lastname;
      // console.log("ud",fullname);
      this.setState({ userID: fullname });

      if (this.state.EX_ATTRIBUTES[i].NAME == "SOURCE_LOCATION_TIMEZONE") {
        let fromTimeZone = this.state.EX_ATTRIBUTES[i].VALUE;
        this.setState({ ShipFromTimeZone: fromTimeZone });
      }

      if (this.state.EX_ATTRIBUTES[i].NAME == "USER_TYPE") {
        this.setState({createdByUserRole: this.state.EX_ATTRIBUTES[i].VALUE});
      }

      if (this.state.EX_ATTRIBUTES[i].NAME == "DEST_LOCATION_TIMEZONE") {
        let ToTimeZone = this.state.EX_ATTRIBUTES[i].VALUE;
        this.setState({ ShipToTimeZone: ToTimeZone });
      }

      if (this.state.EX_ATTRIBUTES[i].NAME == "USER_TIMEZONE") {
        let USER_TIMEZON = this.state.EX_ATTRIBUTES[i].VALUE;

        this.setState({ USER_TIMEZONE: USER_TIMEZON });
      }
    }
  }

    if (this.state.createdByUserRole == "BB") {
      this.setState({ AutzCarrier: true });
    }

    var getDoctypelist = this.getDocType();

    if (typeof this.state.EX_DOCREF != "undefined") {
      var refNo = "";
      for (var i = 0; i < this.state.EX_DOCREF.length; i++) {
        //Doc ref line number update
        var temp = this.state.EX_DOCREF[i].BTD_ID
          ? this.state.EX_DOCREF[i].BTD_ID
          : "";
        if (getDoctypelist.indexOf(this.state.EX_DOCREF[i].BTD_TCO) > -1) {
          if (this.state.FGType === true) {
            $("button.copy-disable").addClass("menu-disable");

            if (this.state.EX_DOCREF[i].BTD_TCO == "73") {
              var getdoctype = this.assignDpSelectedValue(
                this.state.EX_DOCREF[i].BTD_TCO
              );

              console.log("getdoctype", getdoctype);

              //Reference line num
              //This value will not be different, hence its written outside loop
              var intelrefno = this.state.EX_DOCREF[i].BTD_ID;
              //  var ddd=this.state.EX_DOCREF[i].BTD_ID;
              console.log("ddd", intelrefno);
              //IntelRefLineNum:intelrefno,
              this.setState({
                DocTypeValue: { value: "", text: getdoctype },
                intelrefnum: intelrefno,
                docTypeStatus: true,
              });
            } else if (this.state.EX_DOCREF[i].BTD_TCO == "Z02") {
              var getdoctype = this.assignDpSelectedValue(
                this.state.EX_DOCREF[i].BTD_TCO
              );

              console.log("getdoctype", getdoctype);

              //Reference line num
              //This value will not be different, hence its written outside loop
              var intelrefno = this.state.EX_DOCREF[i].BTD_ID;
              //  var ddd=this.state.EX_DOCREF[i].BTD_ID;
              console.log("ddd", intelrefno);
              //IntelRefLineNum:intelrefno,

              this.setState({
                DocTypeValue: { value: "", text: getdoctype },
                intelrefnum: intelrefno,
                docTypeStatus: true,
              });
            }
          } else {
            //if(vm.documentTypeArr.includes(docRef[i].BTD_TCO)){ // commented as this doesnt work in chrome
            if (refNo == "") {
              refNo = temp;
              //This value will not be different, hence its written outside loop
              //RequestService.assignDpSelectedValue("idIntelDocType", docRef[i].BTD_TCO);
              var getdoctype = this.assignDpSelectedValue(
                this.state.EX_DOCREF[i].BTD_TCO
              );

              console.log("getdoctype", getdoctype);

              //Reference line num
              //This value will not be different, hence its written outside loop
              var intelrefno = this.state.EX_DOCREF[i].BTD_ID;
              //  var ddd=this.state.EX_DOCREF[i].BTD_ID;
              console.log("ddd", intelrefno);
              //IntelRefLineNum:intelrefno,
              this.setState({
                DocTypeValue: { value: "", text: getdoctype },
                intelrefnum: intelrefno,
              });
            } else {
              refNo = refNo + "," + temp;
              // this.setState({intelrefnum:temp});
            }
          }
        }

        if (this.state.EX_DOCREF[i].BTD_TCO == "T54") {
          this.state.HawbNumber = this.state.EX_DOCREF[i].BTD_ID; 
          this.setState({
            HawbNumber: this.state.EX_DOCREF[i].BTD_ID 
          });


        }

        if (this.state.EX_DOCREF[i].BTD_TCO == "004") {
          this.state.ProNumber = this.state.EX_DOCREF[i].BTD_ID;
          this.setState({
            ProNumber: this.state.EX_DOCREF[i].BTD_ID 
          });
        }

        if (this.state.EX_DOCREF[i].BTD_TCO === "ZDV") {
          this.state.documentVersion = this.state.EX_DOCREF[i].BTD_ID;
          this.setState({
            documentVersion: this.state.EX_DOCREF[i].BTD_ID
          });
        }
      }
    }

    let Request_Pickup_Date = this.state.EX_HEADER.PLANNED_SHIPMENT_START;
    let Request_Delivery_Date = this.state.EX_HEADER.PLANNED_SHIPMENT_END;

    var RD = new Date(Request_Delivery_Date),
      month = "" + (RD.getMonth() + 1),
      day = "" + RD.getDate(),
      year = RD.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    var requestDelivery = month + "/" + day + "/" + year;
    var d = new Date(Request_Pickup_Date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    var requestPickup = month + "/" + day + "/" + year;

    var R_code = this.state.EX_HEADER.YNCRM_REASON_CODE;
    var reasonCode = this.getServiceDesc(R_code);
    // var DocType_Code = this.getDocType(this.state.EX_HEADER.YTOR_DOCSTATUS);

    ;
    var FrmloadPortRegionDropdowns = this.loadPortRegionDropdowns(
      this.state.EX_ADDRESS.DEST_COUNTRY.split("-")[0],
      "To"
    );

    var ToloadPortRegionDropdowns = this.loadPortRegionDropdowns(
      this.state.EX_ADDRESS.SOURCE_COUNTRY.split("-")[0],
      "From"
    );

    var fromcountry_dt = this.getFromcountry(
      this.state.EX_ADDRESS.SOURCE_COUNTRY
    );

    var incoterm_code = this.getinCoterm(this.state.EX_HEADER.INC_CLASS_CODE);
    if (this.state.EX_HEADER.INC_CLASS_CODE != undefined) {
      this.setState({
        incotermValue: {
          value: this.state.EX_HEADER.INC_CLASS_CODE,
          text: incoterm_code,
        },
      });
    } else {
      this.setState({
        incotermValue: {
          value: this.state.incoTermsData,
          text: "Select Incoterms",
        },
        inconterms_disabled: false,
      });
    }

    var parent_SCAC = this.getParentSCAC(this.state.EX_HEADER.TSP_SCAC);
    if (this.state.EX_HEADER.TSP_SCAC != undefined) {
      this.setState({
        ParentScacCode: {
          value: this.state.EX_HEADER.TSP_SCAC,
          text: parent_SCAC,
        },
      });
    } else {
      this.setState({
        ParentScacCode: {
          value: this.state.BindParentCode,
          text: "Select Parent Code",
        },
        scacDisabled: false,
      });
    }
    
    if (this.state.FGType === false) {
      var Transport_code = this.getTransCode(this.state.EX_HEADER.TRMODCOD);
      if (this.state.EX_HEADER.TRMODCOD != undefined) {
        this.setState({
          TransportationValue: {
            value: this.state.EX_HEADER.TRMODCOD,
            text: Transport_code,
          },
        });
      } else {
        this.setState({
          TransportationValue: {
            value: this.state.TransportationData,
            text: "Select Transportation Mode",
          },
          transport_disabled: false,
        });
      }
    } else {
      this.setState({
        TransportationValue: { value: "99", text: "99-All Modes" },
        transport_disabled: false,
      });
    }

    var service_Code = this.getServiceCode(this.state.EX_HEADER.YMOV_TYPE);
    if (this.state.EX_HEADER.YMOV_TYPE != undefined) {
      this.setState({
        ServiceCodeValue: {
          value: this.state.EX_HEADER.YMOV_TYPE,
          text: service_Code,
        },
      });
    } else {
      this.setState({
        ServiceCodeValue: {
          value: this.state.ServiceCodeData,
          text: "Select Service Code",
        },
        service_disabled: false,
      });
    }
    if (this.state.FGType === false) {
      var comm_code = this.getCommCode(this.state.EX_HEADER.YCCODE);

      if (this.state.EX_HEADER.YCCODE != undefined) {
        this.setState({
          CommodityValue: {
            value: this.state.EX_HEADER.YCCODE,
            text: comm_code,
          },
        });
      } else {
        this.setState({
          CommodityValue: {
            value: this.state.CommodityData,
            text: "Select Commodity Code",
          },
          comm_disabled: false,
        });
      }
    } else {
      this.setState({
        CommodityValue: { value: "FG", text: "FG-Finished Goods" },
        comm_disabled: true,
      });
    }

    console.log("From Ports value" +this.state.FromPortData);
    console.log("To Ports Value" +this.state.ToPortData);
    var toPortsData = "";
    var toPortExists = false;
    if (this.state.EX_ADDRESS.DEST_PORT != undefined) {
      //change
    // var fromPortsVal = this.state.fromPortsArr.filter(ports => ports.text.split('-')[1] === this.state.EX_ADDRESS.DEST_PORT)
    for (let i = 0; i < this.state.ToPortData.length; i++) {
      if (this.state.ToPortData[i].text.includes(this.state.EX_ADDRESS.DEST_PORT)) {
          console.log(this.state.ToPortData[i].text);
          toPortsData = this.state.ToPortData[i].text;
          toPortExists = true;
      }
  }
  if(toPortExists === false)
  {
    toPortsData = this.state.EX_ADDRESS.DEST_PORT;
  }
       console.log("Value is " +toPortsData);
    //end of change
      this.setState({
        ToportValue: {
          // value: this.state.EX_ADDRESS.DEST_PORT.split("_")[1],
          // text: this.state.EX_ADDRESS.DEST_PORT.split("_")[1],
          //change
          // value: this.state.EX_ADDRESS.DEST_PORT,
          // text: this.state.EX_ADDRESS.DEST_PORT,
          value : toPortsData,
          text : toPortsData,
          //end of change
        },
      });
    } else {
      this.setState({
        ToportValue: { value: ToloadPortRegionDropdowns, text: "Select Port" },
        toPort_disabled: false,
      });
    }

    if (this.state.EX_ADDRESS.DEST_COUNTRY != undefined) {
      this.setState({
        toCountryValue: {
          value: this.state.EX_ADDRESS.DEST_COUNTRY,
          text: this.state.EX_ADDRESS.DEST_COUNTRY,
        },
      });
    } else {
      this.setState({
        toCountryValue: { value: null, text: "Select Country" },
        Tocntry_disabled: false,
      });
    }

    if (this.state.EX_ADDRESS.SOURCE_COUNTRY != undefined) {
      this.setState({
        FromCountryValue: {
          value: this.state.EX_ADDRESS.SOURCE_COUNTRY,
          text: this.state.EX_ADDRESS.SOURCE_COUNTRY,
        },
      });
    } else {
      this.setState({
        FromCountryValue: { value: null, text: "Select Country" },
        cntry_Disabled: false,
      });
    }
    if (this.state.EX_ADDRESS.SOURCE_PORT != undefined) {
      //change
      var fromPortsData = "";
      var fromPortExists = false;
      for (let i = 0; i < this.state.FromPortData.length; i++) {
        if (this.state.FromPortData[i].text.includes(this.state.EX_ADDRESS.SOURCE_PORT)) {
            console.log(this.state.FromPortData[i].text);
            fromPortsData = this.state.FromPortData[i].text;
            fromPortExists = true;
        }
    }
    if(fromPortExists === false)
    {
      fromPortsData = this.state.EX_ADDRESS.SOURCE_PORT;
    }
    //end of change
      this.setState({
        FromPortValue: {
          // value: this.state.EX_ADDRESS.SOURCE_PORT.split("_")[1],
          // text: this.state.EX_ADDRESS.SOURCE_PORT.split("_")[1],
          //change
          // value: this.state.EX_ADDRESS.SOURCE_PORT,
          // text: this.state.EX_ADDRESS.SOURCE_PORT,
          value : fromPortsData,
          text : fromPortsData,
          //end of change
        },
      });
    } else {
      this.setState({
        FromPortValue: {
          value: FrmloadPortRegionDropdowns,
          text: "select Port",
        },
        frmPort_disabled: false,
      });
    }

    if (this.state.EX_HEADER.YTPT != undefined) {
      this.setState({ tptValue: this.state.EX_HEADER.YTPT });
    } else {
      this.setState({ tptValue: "", tpt_disabled: false });
    }

    if (this.state.EX_HEADER.INC_TRANSF_LOC_N != undefined) {
      this.setState({
        Shiplocationvalue: this.state.EX_HEADER.INC_TRANSF_LOC_N,
      });
    } else {
      this.setState({ Shiplocationvalue: null, location_disabled: false });
    }

    if (this.state.EX_ADDRESS.SOURCE_ADDRESS != undefined) {
      this.setState({
        shipfromAddressValue: this.state.EX_ADDRESS.SOURCE_ADDRESS,
      });
    } else {
      this.setState({ shipfromAddressValue: null, Frmaddress_disabled: false });
    }

    if (this.state.EX_ADDRESS.SOURCE_CITY != undefined) {
      this.setState({ shipFromCityValue: this.state.EX_ADDRESS.SOURCE_CITY });
    } else {
      this.setState({ shipFromCityValue: null, frmCity_disabled: false });
    }
    if (this.state.FGType === false) {
      if (this.state.EX_ADDRESS.SOURCE_COUNTRY != undefined) {
        this.setState({
          FromCountryValue: {
            value: this.state.EX_ADDRESS.SOURCE_COUNTRY,
            text: fromcountry_dt,
          },
        });
      } else {
        this.setState({ FromCountryValue: null, cntry_Disabled: false });
      }
    }

    if (this.state.EX_ADDRESS.SOURCE_REGION != undefined) {
      this.setState({
        fromRegionValue: {
          value: this.state.EX_ADDRESS.SOURCE_REGION,
          text: this.state.EX_ADDRESS.SOURCE_REGION,
        },
      });
    } else {
      this.setState({
        fromRegionValue: {
          value: this.state.FromRegionData,
          text: "Select Region",
        },
        frmRegion_disabled: false,
      });
    }

    if (this.state.EX_HEADER.YNCRM_REASON_CODE != undefined) {
      this.setState({
        reasoncodeValue: {
          value: this.state.EX_HEADER.YNCRM_REASON_CODE,
          text: reasonCode,
        },
      });
    } else {
      this.setState({
        reasoncodeValue: {
          value: this.state.BindReasonCode,
          text: "Select Resaon Code",
        },
        reasonDisabled: false,
      });
    }

    if (this.state.EX_ADDRESS.DEST_REGION != undefined) {
      this.setState({
        ToRegionValue: {
          value: this.state.EX_ADDRESS.DEST_REGION,
          text: this.state.EX_ADDRESS.DEST_REGION,
        },
      });
    } else {
      this.setState({
        ToRegionValue: {
          value: this.state.ToRegionData,
          text: "Select Region",
        },
        Toregion_disabled: false,
      });
    }

    if (this.state.EX_ADDRESS.SOURCE_ZIP != undefined) {
      this.setState({ FromZipCode: this.state.EX_ADDRESS.SOURCE_ZIP });
    } else {
      this.setState({ FromZipCode: "", frmzipCode_disabled: false });
    }

    if (this.state.EX_ADDRESS.SOURCE_LOCATION != undefined) {
      this.setState({ ShipFromLocat: this.state.EX_ADDRESS.SOURCE_LOCATION });
    } else {
      this.setState({ ShipFromLocat: null, frmlocation: false });
    }

    if (this.state.EX_ADDRESS.SOURCE_COMPANYNAME != undefined) {
      this.setState({
        ShipFromcompName: this.state.EX_ADDRESS.SOURCE_COMPANYNAME,
      });
    } else {
      this.setState({ ShipFromcompName: null, comp_name_disabled: false });
    }

    if (this.state.EX_ADDRESS.SOURCE_CONTACTNAME != undefined) {
      this.setState({
        FromContactName: this.state.EX_ADDRESS.SOURCE_CONTACTNAME,
      });
    } else {
      this.setState({ FromContactName: null, cntname_disabled: false });
    }

    if (this.state.EX_ADDRESS.SOURCE_CONTACTPHONENO != undefined) {
      this.setState({
        FromShipPhone: this.state.EX_ADDRESS.SOURCE_CONTACTPHONENO,
      });
    } else {
      this.setState({ FromShipPhone: null, frmPhone_disabled: false });
    }

    if (this.state.EX_ADDRESS.SOURCE_CONTACTEMAIL != undefined) {
      this.setState({
        FromShipEmailId: this.state.EX_ADDRESS.SOURCE_CONTACTEMAIL,
      });
    } else {
      this.setState({ FromShipEmailId: null, frmemail_disabled: false });
    }

    if (this.state.EX_ADDRESS.DEST_CONTACTEMAIL != undefined) {
      this.setState({ ToEmail: this.state.EX_ADDRESS.DEST_CONTACTEMAIL });
    } else {
      this.setState({ ToEmail: null, toEmail_disabled: false });
    }

    if (this.state.EX_ADDRESS.DEST_CONTACTNAME != undefined) {
      this.setState({ ToContactName: this.state.EX_ADDRESS.DEST_CONTACTNAME });
    } else {
      this.setState({ ToContactName: null, Tocont_disabled: false });
    }

    if (this.state.EX_ADDRESS.DEST_CONTACTPHONENO != undefined) {
      this.setState({
        ToPhoneNumber: this.state.EX_ADDRESS.DEST_CONTACTPHONENO,
      });
    } else {
      this.setState({ ToPhoneNumber: null, Tophone_disabled: false });
    }

    if (this.state.EX_ADDRESS.DEST_CITY != undefined) {
      this.setState({ TocityValue: this.state.EX_ADDRESS.DEST_CITY });
    } else {
      this.setState({ TocityValue: null, toCity_disabled: false });
    }

    if (this.state.EX_ADDRESS.DEST_ADDRESS != undefined) {
      this.setState({ ToAddressline: this.state.EX_ADDRESS.DEST_ADDRESS });
    } else {
      this.setState({ ToAddressline: null, Toadd_disabled: false });
    }

    if (this.state.EX_ADDRESS.DEST_ZIP != undefined) {
      this.setState({ ToZipvalue: this.state.EX_ADDRESS.DEST_ZIP });
    } else {
      this.setState({ ToZipvalue: null, toZip_disabled: false });
    }

    if (this.state.EX_ADDRESS.DEST_COMPANYNAME != undefined) {
      this.setState({ ToCompanyname: this.state.EX_ADDRESS.DEST_COMPANYNAME });
    } else {
      this.setState({ ToCompanyname: null, Tocompname_disabled: false });
    }

    if (this.state.EX_ADDRESS.DEST_LOCATION != undefined) {
      this.setState({ ToLocationId: this.state.EX_ADDRESS.DEST_LOCATION });
    } else {
      this.setState({ ToLocationId: null, toLocat: false });
    }

    this.setState({
      ReqPickupDate: new Date(requestPickup),
      ReqDeliveryDate: new Date(requestDelivery),
      FrombpID: this.state.EX_ADDRESS.SOURCE_BP,
      ToBpIdValue: this.state.EX_ADDRESS.DEST_BP,
    });

    $("#customBox ul li a.Tab_item").removeClass("menu-disable");

    //enable / disable fields for FG Types for those fields which doesnt have values from backend
    if(this.state.FGType === true)
    {
     
      $("button.copy-disable").addClass("menu-disable");
      //default Enable the date fields.
      this.setState({pickup_disabled : false,
        delivery_disabled : false,
      EditbtnDisabled : true,
      service_disabled : false,
      frmPort_disabled: false,
      cntry_Disabled: false,
      frmRegion_disabled: false,
      Tocntry_disabled: false,
      Toregion_disabled: false,
      toPort_disabled: false,});

        //Enable if the values are empty
        
        if(this.state.specialinstruct == undefined)
        {
          this.setState({specialInst_disabled : false})
        }

        if(this.state.brokerNameValue == undefined)
        {
          this.setState({contName_disabled : false})
        }
        if(this.state.brokerPhonenumbervalue == undefined)
        {
          this.setState({phone_disabled : false});
        }

        if(this.state.brokeremailvalue == undefined)
        {
          this.setState({broker_disabled : false});
        }

        if(this.state.brokerValue == undefined)
        {
          this.setState({broker_disabled : false})
        }

    }

    this.setState({ blocking: false });
  }

  GetAuthorList(val) {
    var author = "";
    for (var i = 0; i < this.state.authorization.length; i++) {
      if (this.state.authorization[i].idsid == val) {
        author = this.state.authorization[i].name;
        // IntelRefnums = descParts.split('-')[1];
      }
    }
    return author;
  }

  assignDpSelectedValue(value) {
    var IntelRefnums = "";
    for (var i = 0; i < this.state.DocumentTypeData.length; i++) {
      if (this.state.DocumentTypeData[i].value == value) {
        var descParts = this.state.DocumentTypeData[i].text;
        IntelRefnums = descParts;
      }
    }
    return IntelRefnums;
  }

  //  shouldComponentUpdate(){

  //      console.log("",this.state.isEditClicked)

  //  }

  FO_EnableEdit() {
    this.setState({ currentTab: "generalDetails", savebtnDisabled: true });

    var Tophone = "";
    var fromphone = "";
    if (this.state.ToPhoneNumber != null)
      Tophone = this.state.ToPhoneNumber.split(" ")[1];
    if (this.state.FromShipPhone != null)
      fromphone = this.state.FromShipPhone.split(" ")[1];
    this.setState({ ToPhoneNumber: Tophone, FromShipPhone: fromphone });

    $("button.edit-disable,button.copy-disable,button.can_disable").addClass(
      "menu-disable"
    );
    $("#customBox ul li.GDdisabled a,.tab-content #rate").addClass("active");
    $(
      "#customBox ul li a.Tab_inv,#customBox ul li a.Tab_item,#customBox ul li a.Tab_bid,#customBox ul li a.Tab_status,.tab-content #It_d,.tab-content #Bid_d,.tab-content #Inv_d,.tab-content #Stat_d"
    ).removeClass("active");
    $("a.Tab_item,a.Tab_bid, a.Tab_status,a.Tab_inv,a.Tab_inv").addClass("menu-disable");
    $("button.Save-disable").removeClass("menu-disable");

    console.log("tab", this.state.tabChanged);
    this.state.savebtnDisabled = false;
    this.state.isEditClicked = true;
    this.setState({
      isEditClicked: true,
      EditbtnDisabled: true,
      savebtnDisabled: false,
    });

    //sessionStorage.setItem("IseditClicked",this.state.isEditClicked);



    if (this.state.FGType === true) {
      this.setState({
        abbrDisabled: false,
        isNew: false,
        ParentScacCode: { value: "", text: "Select Parent SCAC" },
        scacDisabled: false,
        delivery_disabled: false,
        frmPort_disabled: false,
        frmzipCode_disabled: false,
        reasonDisabled: true,
        ncrmcomtDisabled: true,
        Req_phone_disabled: false,
        segment_disabled: false,
        authorize_disabled: false,
        comp_name_disabled: true,
        fromhouse_disabled: true,
        Frmaddress_disabled: true,
        frmCity_disabled: true,
        cntry_Disabled: false,
        frmRegion_disabled: false,
        zipCode_disabled: true,
        cntname_disabled: false,
        frmPhone_disabled: false,
        frmemail_disabled: false,
        Tocompname_disabled: true,
        Toaddline_disabled: true,
        toCity_disabled: true,
        Tocntry_disabled: false,
        Toregion_disabled: false,
        toPort_disabled: false,
        toZip_disabled: false,
        Tocont_disabled: false,
        Tophone_disabled: false,
        toEmail_disabled: false,
        Toadd_disabled: true,
        pickup_disabled: false,
        broker_disabled: false,
        contName_disabled: true,
        phone_disabled: false,
        broker_disabled: false,
        service_disabled: false,
        comm_disabled: true,
        transport_disabled: false,
        tpt_disabled: false,
        inconterms_disabled: false,
        location_disabled: false,
        intelrefer_disabled: true,
        docTypeStatus: true,
        doctype_disabled: true,
        specialInst_disabled: false,
        CommodityValue: { value: "FG", text: "FG-Finished Goods" },
      });
    } else {
      toast.warning(
        "This Request# is in EDIT mode , Please ensure to Click SAVE to proceed further",{theme:"colored"}
      );

      this.setState({
        abbrDisabled: false,
        isNew: false,
        scacDisabled: false,
        delivery_disabled: false,
        frmPort_disabled: false,
        frmzipCode_disabled: false,
        reasonDisabled: false,
        ncrmcomtDisabled: false,
        Req_phone_disabled: false,
        segment_disabled: false,
        authorize_disabled: false,
        comp_name_disabled: false,
        fromhouse_disabled: false,
        Frmaddress_disabled: false,
        frmCity_disabled: false,
        cntry_Disabled: false,
        frmRegion_disabled: false,
        zipCode_disabled: false,
        cntname_disabled: false,
        frmPhone_disabled: false,
        frmemail_disabled: false,
        Tocompname_disabled: false,
        Toaddline_disabled: false,
        toCity_disabled: false,
        Tocntry_disabled: false,
        Toregion_disabled: false,
        toPort_disabled: false,
        toZip_disabled: false,
        Tocont_disabled: false,
        Tophone_disabled: false,
        toEmail_disabled: false,
        Toadd_disabled: false,
        pickup_disabled: false,
        broker_disabled: false,
        contName_disabled: false,
        phone_disabled: false,
        broker_disabled: false,
        service_disabled: false,
        comm_disabled: false,
        transport_disabled: false,
        tpt_disabled: false,
        inconterms_disabled: false,
        location_disabled: false,
        intelrefer_disabled: false,
        doctype_disabled: false,
        specialInst_disabled: false,
      });
    }
    this.setState({editTabRefresh: true});
  }

  FO_Copy() {
    //Anitha's changes
    
    if (this.state.roleList.BB == "True") {
      var FOType = [];
    var docTypeObj = {};
    docTypeObj["FOType"] = "ZSSB";
    docTypeObj["text"] = "Intel Shipment Request";
    FOType.push(docTypeObj);

    var docTypeObj = {};
    docTypeObj["FOType"] = "ZMSB";
    docTypeObj["text"] = "Multi-Bid Request";
    FOType.push(docTypeObj);

    var docTypeObj = {};
    docTypeObj["FOType"] = "ZEXC";
    docTypeObj["text"] = "Invoice Adjustment Request";
    FOType.push(docTypeObj);

    this.setState({ documentData: FOType });
    }
    else if(this.state.roleList.CARRIER === "True")
    {
      var FOType = [];
      var docTypeObj = {};
      docTypeObj["FOType"] = "ZSSB";
      docTypeObj["text"] = "Intel Shipment Request";
      FOType.push(docTypeObj);
  
      // var docTypeObj = {};
      // docTypeObj["FOType"] = "ZMSB";
      // docTypeObj["text"] = "Multi-Bid Request";
      // FOType.push(docTypeObj);
  
      var docTypeObj = {};
      docTypeObj["FOType"] = "ZEXC";
      docTypeObj["text"] = "Invoice Adjustment Request";
      FOType.push(docTypeObj);
  
      this.setState({ documentData: FOType });
    }

    else if(this.state.roleList.CW === "True")
    {
      var FOType = [];
      var docTypeObj = {};
      docTypeObj["FOType"] = "ZSSB";
      docTypeObj["text"] = "Intel Shipment Request";
      FOType.push(docTypeObj);
  
      // var docTypeObj = {};
      // docTypeObj["FOType"] = "ZMSB";
      // docTypeObj["text"] = "Multi-Bid Request";
      // FOType.push(docTypeObj);
  
      // var docTypeObj = {};
      // docTypeObj["FOType"] = "ZEXC";
      // docTypeObj["text"] = "Invoice Adjustment Request";
      // FOType.push(docTypeObj);
  
      this.setState({ documentData: FOType });
    }

    this.props.location.state.isNew = true;
    let UserDetail = JSON.parse(sessionStorage.getItem("profile"));
    var userName = UserDetail["FIRST_NAME"] + " " + UserDetail["LAST_NAME"];
    var current_email = UserDetail.EMAIL_ID;
    this.setState({
      currentTab: "generalDetails",
      ResPhonenumber: "",
      userEmail: current_email,
      userID: userName,
    });

    if (this.state.roleList.CARRIER == "True") {
      // var parent_SCAC = this.getParentSCAC(profile.CARRIER_SCAC);
      this.setState({ scacDisabled: true, abbrDisabled: true });
      this.setState({ AutzCarrier: false });
      $("a.Tab_status").addClass("menu-disable");
    } else if (this.state.roleList.BB == "True") {
      this.setState({
        AutzCarrier: true,
        tobeauthorValue: [],
        scacDisabled: false,
        abbrDisabled: false,
      });
    } else {
      this.setState({ scacDisabled: false, abbrDisabled: false });
    }

    var Tophone = this.state.ToPhoneNumber != null? this.state.ToPhoneNumber.split(" ")[1]: "";
    var fromphone = this.state.FromShipPhone !=null? this.state.FromShipPhone.split(" ")[1]: "";
    this.setState({ ToPhoneNumber: Tophone, FromShipPhone: fromphone });

    this.setState({
      isNew: true,
      savebtnDisabled: false,
      bindtextAndId: "",
      docDisabled: false,
      FO_Display_Item: [],
      DocTypeValue: { text: "Select Doc Type" },
      delivery_disabled: false,
      frmPort_disabled: false,
      frmzipCode_disabled: false,
      reasonDisabled: false,
      ncrmcomtDisabled: false,
      Req_phone_disabled: false,
      segment_disabled: false,
      authorize_disabled: false,
      comp_name_disabled: false,
      fromhouse_disabled: false,
      Frmaddress_disabled: false,
      frmCity_disabled: false,
      cntry_Disabled: false,
      frmRegion_disabled: false,
      zipCode_disabled: false,
      cntname_disabled: false,
      frmPhone_disabled: false,
      frmemail_disabled: false,
      Tocompname_disabled: false,
      Toaddline_disabled: false,
      toCity_disabled: false,
      Tocntry_disabled: false,
      Toregion_disabled: false,
      toPort_disabled: false,
      toZip_disabled: false,
      Tocont_disabled: false,
      Tophone_disabled: false,
      toEmail_disabled: false,
      Toadd_disabled: false,
      pickup_disabled: false,
      broker_disabled: false,
      contName_disabled: false,
      phone_disabled: false,
      broker_disabled: false,
      service_disabled: false,
      comm_disabled: false,
      transport_disabled: false,
      tpt_disabled: false,
      inconterms_disabled: false,
      location_disabled: false,
      intelrefer_disabled: false,
      doctype_disabled: false,
      specialInst_disabled: false,
      ncrmcommentvalue: "",
      ReqPickupDate: "",
      ReqDeliveryDate: "",
      intelrefnum: "",
      specialinstruct: "",
      tptValue: "",
    });
    sessionStorage.setItem("DOCSTATUS", "10");

    $("#customBox ul li.GDdisabled a,.tab-content #rate").addClass("active");
    // button.copy-disable

    $(
      "#customBox ul li a.Tab_inv,#customBox ul li a.Tab_item,#customBox ul li a.Tab_bid,#customBox ul li a.Tab_status,.tab-content #It_d,.tab-content #Bid_d,.tab-content #Inv_d,.tab-content #Stat_d"
    ).removeClass("active");
    $("a.Tab_item,a.Tab_bid, a.Tab_status,a.Tab_inv,a.Tab_inv").addClass("menu-disable");
    $("button.copy-disable,button.Edit-disable").addClass("menu-disable");

    $("button.Save-disable").removeClass("menu-disable");

  

    this.setState({copyTabRefresh: true});
  }

  getinCoterm(dd) {
    var c_code = "";
    for (var i = 0; i < this.state.incoTermsData.length; i++) {
      if (this.state.incoTermsData[i].value == dd) {
        var descParts = this.state.incoTermsData[i].text;
        c_code = descParts;
      }
    }
    return c_code;
  }

  getServiceCode(dd) {
    var c_code = "";
    for (var i = 0; i < this.state.ServiceCodeData.length; i++) {
      if (this.state.ServiceCodeData[i].value == dd) {
        var descParts = this.state.ServiceCodeData[i].text;
        c_code = descParts;
      }
    }
    return c_code;
  }

  getTransCode(dd) {
    var c_code = "";
    for (var i = 0; i < this.state.TransportationData.length; i++) {
      if (this.state.TransportationData[i].value == dd) {
        var descParts = this.state.TransportationData[i].text;
        c_code = descParts;
      }
    }
    return c_code;
  }

  getFromcountry(dd) {
    ;
    var c_code = "";
    for (var i = 0; i < this.state.FromcountryList.length; i++) {
      if (this.state.FromcountryList[i].text == dd) {
        var descParts = this.state.FromcountryList[i].text;
        c_code = descParts;
      }
    }
    return c_code;
  }

  getParentSCAC(dd) {
    var c_code = "";
    var descPartss = "";
    for (var i = 0; i < this.state.BindParentCode.length; i++) {
      if (this.state.BindParentCode[i].text == dd) {
        var descParts = this.state.BindParentCode[i].text;
        descPartss = this.state.BindParentCode[i].value;
        c_code = descParts;
      }
    }
    this.setState({abbvalue :descPartss});

    return c_code;
  }

  getCommCode(dd) {
    var c_code = "";
    for (var i = 0; i < this.state.CommodityData.length; i++) {
      if (this.state.CommodityData[i].value == dd) {
        var descParts = this.state.CommodityData[i].text;
        c_code = descParts;
      }
    }
    return c_code;
  }

  getServiceDesc(dd) {
    var description = "";
    for (var i = 0; i < this.state.BindReasonCode.length; i++) {
      if (this.state.BindReasonCode[i].value == dd) {
        var descParts = this.state.BindReasonCode[i].text;
        description = descParts;
      }
    }
    return description;
  }

  getDocType() {
    var d_Code = [];
    for (var i = 0; i < this.state.DocumentTypeData.length; i++) {
      if (this.state.DocumentTypeData[i].value) {
        var descParts = this.state.DocumentTypeData[i].value;
        d_Code.push(descParts);
      }
    }
    return d_Code;
  }

  async NcrmSearchView() {
    const SearchIDvalue = this.props.location.state;
  }

  async ParentSCAC() {
    let profile = JSON.parse(sessionStorage.getItem("profile"));
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_CARRIERS_SCAC";
    inputObj["Input"] = "";
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    //console.log("resultP--->",result);
    this.setState({ BindParentCode: result, ParentFilter: result });
    if (this.state.BindParentCode.length > 0) {
      if (this.state.roleList.CARRIER == "True") {
        var parent_SCAC = this.getParentSCAC(profile.CARRIER_SCAC);
        this.setState({
          scacDisabled: true,
          abbrDisabled: true,
          ParentScacCode: { value: profile.CARRIER_SCAC, text: parent_SCAC },
          isStatusHidden: true,
        });
      }
    }
  }

  async ReasonCode() {
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_NCRM_REASON_CODES";
    inputObj["Input"] = "";
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    //console.log("reason",result);
    this.setState({ BindReasonCode: result, filterReasonCode: result });
  }

  async F4_TO_BE_AUTHORIZED_BY() {
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_TO_BE_AUTHORIZED_BY";
    inputObj["Input"] = "";
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    console.log("Auth", result);
    this.setState({ authorization: result,authFilterData : result });
  }

  // async getSegmentData() {

  //   let props = {};
  //   let inputObj = {};
  //   props["query"] = constants.serviceRoot;
  //   props["headers"] = constants.serviceHeaders;
  //   inputObj["Activity"] = "F4_WF_SEGMENTS";
  //   inputObj["Input"] = "";
  //   props.input = inputObj;
  //   const result = await GatewayGet(props, props.input);
  //   //console.log("segmentsData",result);
  //   this.setState({ segmentsData: result });

  // }

  getDate = () => {
    var dates = new Date();
    const myDate = dates.toLocaleString();

    this.setState({ myDate });
  };

  async F4_COUNTRIES_REGIONS_V1() {
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_COUNTRIES_REGIONS_V1";
    inputObj["Input"] = "";
    props.input = inputObj;

    const F4_COUNTRIES_REGIONS = await GatewayGet(props, props.input);
    console.log("F4_COUNTRIES_REGIONS", F4_COUNTRIES_REGIONS);
    //console.log("FromcountryList cntRegiion",F4_COUNTRIES_REGIONS);
    this.state.comp_region = F4_COUNTRIES_REGIONS;
    this.setState({ comp_region: F4_COUNTRIES_REGIONS });
    var CountriesID = this.getUniqueCountries(F4_COUNTRIES_REGIONS);
    var jsonArrDp = [];
    for (var i = 0; i < CountriesID.length; i++) {
      var jsonDp = {};
      jsonDp.text = CountriesID[i];
      jsonDp.value = CountriesID[i].split("-")[0];
      jsonArrDp.push(jsonDp);
    }
    this.setState({
      FromcountryList: jsonArrDp,
      filterCountryList: jsonArrDp,
      TocountryList: jsonArrDp,
      ToFiltercountryList: jsonArrDp,
    });
  }

  loadPortRegionDropdowns(countryid, type) {
    if (type == "From") {
      var filterdataFrom = [];
      this.state.comp_region.forEach(function (value, key) {
        if (value.countryid == countryid) {
          filterdataFrom.push(value);
        }

        // this.state.Tcountry_ID=filterdataFrom;
        //    this.state.ToCountry_ID=filterdataFrom;
      });

      var RegionsArr = this.getUniqueRegions(filterdataFrom);

      console.log("RegionsArr", RegionsArr);
      var PortsArr = this.getUniquePorts(filterdataFrom);
      console.log("Ports Array" +PortsArr);
      this.state.fromPortsArr = PortsArr;

      var FromRegions = [];
      for (var i = 0; i < RegionsArr.length; i++) {
        var jsonDp = {};
        jsonDp.text = RegionsArr[i];
        jsonDp.value = RegionsArr[i].split("-")[0];
        FromRegions.push(jsonDp);
      }

      this.setState({
        FromRegionData: FromRegions,
        filterRegionData: FromRegions,
      });

      var FromPorts = [];
      

      for (var i = 0; i < PortsArr.length; i++) {
        var jsonDp = {};
        jsonDp.text = PortsArr[i];
        jsonDp.value = PortsArr[i].split("-")[0];
        FromPorts.push(jsonDp);
      }
      this.state.FromPortData=FromPorts;
      this.setState({ FromPortData: FromPorts, FromPortFilter: FromPorts });

      console.log("FromPorts FromPorts FromPorts", FromPorts);
    } else if (type == "To") {
      var filterdataTo = [];
      this.state.comp_region.forEach(function (value, key) {
        if (value.countryid == countryid) {
          filterdataTo.push(value);
        }
      });

      var RegionsArr = this.getUniqueRegions(filterdataTo);
      var PortsArr = this.getUniquePorts(filterdataTo);
      var ToRegions = [];
      for (var i = 0; i < RegionsArr.length; i++) {
        var jsonDp = {};
        jsonDp.text = RegionsArr[i];
        jsonDp.value = RegionsArr[i].split("-")[0];
        ToRegions.push(jsonDp);
      }
      this.setState({ ToRegionData: ToRegions, ToFilterRegionData: ToRegions });

      var ToPorts = [];
      for (var i = 0; i < PortsArr.length; i++) {
        var jsonDp = {};
        jsonDp.text = PortsArr[i];
        jsonDp.value = PortsArr[i].split("-")[0];
        ToPorts.push(jsonDp);
      }
      this.state.ToPortData=ToPorts;

      this.setState({ ToPortData: ToPorts, ToPortFilterData: ToPorts });
    }
  }

  getUniqueRegions(array) {
    var result = [];
    for (var x = 0; x < array.length; x++) {
      if (typeof array[x].region !== "undefined")
        if (result.indexOf(array[x].region + "-" + array[x].regdes) == -1)
          result.push(array[x].region + "-" + array[x].regdes);
    }
    return result;
  }

  getUniquePorts(array) {
    // console.log("getUniquePorts",array);
    var result = [];
    for (var x = 0; x < array.length; x++) {
      var portID = array[x].port;
      if (typeof portID != "undefined")
        if (
          result.indexOf(
            portID.substring(2, portID.length) + "-" + array[x].portDes
          ) == -1
        )
          result.push(
            portID.substring(2, portID.length) + "-" + array[x].portDes
          );
    }
    return result.sort();
  }

  /************CountryList**************** */
  getUniqueCountries(array) {
    var result = [];
    for (var x = 0; x < array.length; x++) {
      if (result.indexOf(array[x].countryid + "-" + array[x].countrydes) == -1)
        result.push(array[x].countryid + "-" + array[x].countrydes);
    }
    return result;
  }

  getUserDetail() {
    let profile = JSON.parse(sessionStorage.getItem("profile"));
    const result = profile["RESULT"];
    const message = profile["MESSAGE"];
    const emailId = profile["EMAIL_ID"];
    const userIdName = profile["FIRST_NAME"] + " " + profile["LAST_NAME"];
    const timeZone = profile["TIME_ZONE"];
    this.state.userName = profile["FIRST_NAME"] + " " + profile["LAST_NAME"];
    this.state.roleList = profile["ROLE_LIST"];
    const fullUserID = profile["USER_ID"];

    this.setState({
      userID: userIdName,
      userEmail: emailId,
      logginuserId: fullUserID,
    });

    console.log("this.state.roleList", this.state.roleList);

    if (this.state.roleList["BB"] == "True") {
      this.setState({ AutzCarrier: true });
    } else {
      this.setState({ AutzCarrier: false });
    }

    if (this.state.roleList["CW"] == "True") {
      this.setState({
        isBidHiden: true,
        isInvoiceHiden: true,
        isStatusHidden: true,
      });
    } else if (this.state.roleList["CARRIER"] == "True") {
      this.setState({ isStatusHidden: true });
      if (this.state.Tor_Type == "ZEXC") {
        this.setState({ isBidHiden: true });
      }
    } else {
      if (this.state.Tor_Type == "ZEXC") 
      {
      this.setState({ isBidHiden: true });
      }
      else
      {
        this.setState({
          isBidHiden: false,
          isInvoiceHiden: false,
          isStatusHidden: false,
        });
      }
    }
  }

  async getLocationPort(portId, value) {
    //F4_SEARCH_LOCATIONS
    var inputSearchAddr = [{ locationid: portId, locationname: "" }];
    let props = {};
    let inputObj = {};
    let InputJSONString = JSON.stringify(inputSearchAddr);
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_SEARCH_LOCATIONS";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    console.log("result-port", result);
    if (value == "From")
      this.setState({
        PortLocationTimeZone: result[0].locTimeZone,
        portLocationArea: result[0].locationName,
        ShipFromTimeZone: "",
      });
    else
      this.setState({
        ToPortLocationTimeZone: result[0].locTimeZone,
        portLocationArea: result[0].locationName,
        ShipToTimeZone: "",
      });
  }

  loadDocType(Tor_Type) {
    let profile = JSON.parse(sessionStorage.getItem("profile"));
    let Tor_typeValue = Tor_Type;
    var FOType = [];

    if (this.props.location.state.isNew == true && Tor_typeValue == null) {
      if (profile["ROLE_LIST"].CARRIER == "True") {
        var docTypeObj = {};
        docTypeObj["FOType"] = "ZSSB";
        docTypeObj["text"] = "Intel Shipment Request";
        FOType.push(docTypeObj);

        var docTypeObj = {};
        docTypeObj["FOType"] = "";
        docTypeObj["text"] = "";
        //FOType.push(docTypeObj);

        var docTypeObj = {};
        docTypeObj["FOType"] = "ZEXC";
        docTypeObj["text"] = "Invoice Adjustment Request";
        FOType.push(docTypeObj);

        this.setState({ documentData: FOType });
      } else if (profile["ROLE_LIST"].CW == "True") {
        var docTypeObj = {};
        docTypeObj["FOType"] = "ZSSB";
        docTypeObj["text"] = "Intel Shipment Request";
        FOType.push(docTypeObj);

        var docTypeObj = {};
        docTypeObj["FOType"] = "";
        docTypeObj["text"] = "";
        //FOType.push(docTypeObj);

        var docTypeObj = {};
        docTypeObj["FOType"] = "";
        docTypeObj["text"] = "";
        //FOType.push(docTypeObj);
        this.setState({ documentData: FOType });
      } else {
        var docTypeObj = {};
        docTypeObj["FOType"] = "ZSSB";
        docTypeObj["text"] = "Intel Shipment Request";
        FOType.push(docTypeObj);

        var docTypeObj = {};
        docTypeObj["FOType"] = "ZMSB";
        docTypeObj["text"] = "Multi-Bid Request";
        FOType.push(docTypeObj);

        var docTypeObj = {};
        docTypeObj["FOType"] = "ZEXC";
        docTypeObj["text"] = "Invoice Adjustment Request";
        FOType.push(docTypeObj);

        this.setState({ documentData: FOType });
      }
    } else {
      if (Tor_Type == "ZSSB") {
        docTypeObj = {};
        docTypeObj["FOType"] = "ZSSB";
        docTypeObj["text"] = "Intel Shipment Request";
        FOType.push(docTypeObj);
        this.setState({ documentData: FOType });
      } else if (Tor_Type == "ZMSB") {
        docTypeObj = {};
        docTypeObj["FOType"] = "ZMSB";
        docTypeObj["text"] = "Multi-Bid Request";
        FOType.push(docTypeObj);

        this.setState({ documentData: FOType });
      } else if (Tor_Type == "ZEXC") {
        docTypeObj = {};
        docTypeObj["FOType"] = "ZMSB";
        docTypeObj["text"] = "Multi-Bid Request";
        FOType.push(docTypeObj);
        this.setState({ documentData: FOType });
      }
    }
  }

  DocumentTypeChanged = (event) => {
    this.setState({ docValue: event.target.value });
    if (event.target.value.FOType == "ZEXC") {
      this.setState({ scacVisible: true });
      this.setState({ isBidHiden: true });
    }
    if (event.target.value.FOType == "ZMSB") {
      this.setState({ scacVisible: false });
      this.setState({ isBidHiden: false });
    }
    if (event.target.value.FOType == "ZSSB") {
      this.setState({ scacVisible: true });
      this.setState({ isBidHiden: false });
    }
    this.setState({ Tor_Type: event.target.value.FOType });
    // code added 
    this.setState({error_select_doc_type: false});
  };

  Change_reasonCode = (event) => {

    if (this.state.docValue.text === "Select Document Type") {
      toast.error("Please select the Document Type");
      this.setState({error_select_doc_type: true});
    } else {
      this.setState({ reasoncodeValue: event.target.value });
    }
  };

  Change_parentScac = (event) => {
    this.setState({ ParentScacCode: event.target.value });

    var ab = event.target.value;

    var filterdataTo = "";
    this.state.BindParentCode.forEach(function (val, key) {
      if (val.value == ab.value) {
        filterdataTo = val.value;
      }
    });

    this.setState({ abbvalue: filterdataTo });
  };

  handleauthorChange = (event) => {
    this.setState({ tobeauthorValue: [...event.target.value] });
    const autList = [...event.target.value];
    this.checkAuthList(autList);
  };

  checkAuthList(val) {
    if (val.length > 5) {
      toast.error("Please select Max 5 users",{theme:"colored"});
      this.setState({ tobeauthorValue: [] });
      return;
    }
  }

  FromCountrySelected = (event) => {
    this.setState({ FromCountryValue: event.target.value });
    const countryidValue = event.target.value;
    const text = countryidValue.text;
    const val = countryidValue.value;

    this.loadPortRegionDropdowns(val, "From");

    if (event.target.value) {
      this.setState({
        fromRegionValue: { text: "Select Region" },
        FromPortValue: { text: "Select Port" },
      });
    }
  };

  FilterbyCountryList = (event) => {
    this.setState({
      FromcountryList: this.countryfilterDatas(event.filter),
      Cufilter: event.filter.value,
    });
  };

  countryfilterDatas(filter) {
    const data = this.state.filterCountryList.slice();
    return filterBy(data, filter);
  }

  Filter_parentScac = (event) => {
    this.setState({ BindParentCode: this.partfilter(event.filter) });
  };
  partfilter(filter) {
    const data = this.state.ParentFilter.slice();
    return filterBy(data, filter);
  }

  Filter_reasonCode = (event) => {
    this.setState({ BindReasonCode: this.Filter_reasonCodes(event.filter) });
  };
  Filter_reasonCodes(filter) {
    const data = this.state.filterReasonCode.slice();
    return filterBy(data, filter);
  }

  FromRegionfilter = (event) => {
    this.setState({
      FromRegionData: this.fromregionlist(event.filter),
    });
  };

  portfilterList = (event) => {
    this.setState({ FromPortData: this.fromportlist(event.filter) });
  };

  fromportlist(filter) {
    const data = this.state.FromPortFilter.slice();
    return filterBy(data, filter);
  }

  fromregionlist(filter) {
    const data = this.state.filterRegionData.slice();
    return filterBy(data, filter);
  }

  ToCountryFilter = (event) => {
    this.setState({
      TocountryList: this.ToCountrylistFilter(event.filter),
    });
  };

  ToCountrylistFilter(filter) {
    const data = this.state.ToFiltercountryList.slice();
    return filterBy(data, filter);
  }

  FromRegionChanged = (event) => {
    this.setState({ fromRegionValue: event.target.value });
    if (event.target.value) {
      this.setState({ FromPortValue: { text: "Select Port" } });
    }
  };
  FromportChanged = (event) => {
    this.setState({ FromPortValue: event.target.value });
    var frmport = "PORT_" + event.target.value.value.toUpperCase();
    this.getLocationPort(frmport, "From");
  };

  ToCountryChanged = (event) => {
    this.setState({ toCountryValue: event.target.value });
    const TocountryidValue = event.target.value;
    const text = TocountryidValue.text;
    const val = TocountryidValue.value;
    console.log(val, text);
    this.loadPortRegionDropdowns(val, "To");

    if (event.target.value) {
      this.setState({
        ToRegionValue: { text: "Select Region" },
        ToportValue: { text: "Select Port" },
      });
    }
  };

  ToRegionChanged = (event) => {
    this.setState({ ToRegionValue: event.target.value });

    if (event.target.value) {
      this.setState({ ToportValue: { text: "Select Port" } });
    }
  };

  ToregionFilterChanged = (event) => {
    this.setState({ ToRegionData: this.toregionmasterdata(event.filter) });
  };

  toregionmasterdata(filter) {
    const data = this.state.ToFilterRegionData.slice();
    return filterBy(data, filter);
  }

  ToportFilter = (event) => {
    this.setState({ ToPortData: this.toportmasterdata(event.filter) });
  };
  toportmasterdata(filter) {
    const data = this.state.ToPortFilterData.slice();
    return filterBy(data, filter);
  }

  ToportChanged = (event) => {
    this.setState({ ToportValue: event.target.value });
    var toPort = "PORT_" + event.target.value.value.toUpperCase();
    this.getLocationPort(toPort, "To");
  };

  /***********incoTermsData******************/

  //F4_INCOTERMS
  async F4_INCOTERMS() {
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_INCOTERMS";
    inputObj["Input"] = "";
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    //console.log("Incon result",result);

    var Inconterm = [];
    for (var i = 0; i < result.length; i++) {
      if (result[i].value) {
        var obj = {};
        obj.text = result[i].value + "-" + result[i].text;
        obj.value = result[i].value;
        Inconterm.push(obj);
      }
    }

    this.setState({ incoTermsData: Inconterm, inConFilterData: Inconterm });
  }

  incoTermChanged = (event) => {
    this.setState({ incotermValue: event.target.value });
  };
  IncoTermFilter = (event) => {
    this.setState({ incoTermsData: this.incorTerms(event.filter) });
  };
  incorTerms(filter) {
    const data = this.state.inConFilterData.slice();
    return filterBy(data, filter);
  }

  /************************************** */

  /**********service code********** */

  async F4_SERVICE_CODE() {
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_SERVICE_CODE";
    inputObj["Input"] = "";
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    // const getsrv=this.getService(result);

    var SVCcode = [];
    for (var i = 0; i < result.length; i++) {
      if (result[i].value) {
        var obj = {};
        obj.text = result[i].value + "-" + result[i].text;
        obj.value = result[i].value;
        SVCcode.push(obj);
      }
    }

    this.setState({ ServiceCodeData: SVCcode, ServiceCodeFilter: SVCcode });
  }

  Servicecodechanged = (event) => {
    this.setState({ ServiceCodeValue: event.target.value });
  };

  ServiceCodeFilter = (event) => {
    this.setState({ ServiceCodeData: this.serviceFilter(event.filter) });
  };
  serviceFilter(filter) {
    const data = this.state.ServiceCodeFilter.slice();
    return filterBy(data, filter);
  }

  /*************************** */

  /***************DocType***************** */

  async F4_DOCUMENT_TYPE() {
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_DOCUMENT_TYPE";
    inputObj["Input"] = "";
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    console.log("Doc result", result);

    var DocCode = [];
    for (var i = 0; i < result.length; i++) {
      if (result[i].value) {
        var obj = {};
        obj.text = result[i].text;
        obj.value = result[i].value;
        DocCode.push(obj);
      }
    }

    this.setState({ DocumentTypeData: DocCode, DocumentTypeFilter: DocCode });
  }

  /*********Transportation******** */

  async F4_TRANSPORTATION_MODE() {
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_TRANSPORTATION_MODE";
    inputObj["Input"] = "";
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    console.log("Transport result", result);

    var TranCode = [];
    for (var i = 0; i < result.length; i++) {
      if (result[i].value) {
        var obj = {};
        obj.text = result[i].value + "-" + result[i].text;
        obj.value = result[i].value;
        TranCode.push(obj);
      }
    }

    this.setState({ TransportationData: TranCode });
  }
  /***************************************** */

  async F4_SERVICE_TYPE() {
    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "F4_SERVICE_TYPE";
    inputObj["Input"] = "";
    props.input = inputObj;
    const result = await GatewayGet(props, props.input);
    console.log(result)
    // const commd = this.Extractcommodity(result);
    //console.log("resultssssssservice Type",result);

    var ccode = [];
    for (var i = 0; i < result.length; i++) {
      if (result[i].value) {
        var obj = {};
        obj.text = result[i].value + "-" + result[i].text;
        obj.value = result[i].value;
        ccode.push(obj);
      }
    }

    //this.setState({ ServiceCodeData: SVCcode, ServiceCodeFilter: SVCcode });

    this.setState({ CommodityData: ccode });
  }
  Extractcommodity(array) {}

  getrequestnumber = (event) => {
    var value = event.target.value;
    value = value.replace(/[^0-9]/gi, "");
    //  this.setState({ResPhonenumber}​​​);
   this.setState({ResPhonenumber: value });
  };

  requestNameChanged = (event) => {
    this.setState({ userID: event.target.value });
  };
  Getemailchanged = (event) => {
    this.setState({ userEmail: event.target.value });
  };

  ncrmCommentChanged = (event) => {
    this.setState({ ncrmcommentvalue: event.target.value });
  };

  ShipFromLocationChanged = (event) => {
    this.setState({ ShipFromLocat: event.target.value });
  };
  companynameChanged = (event) => {
    this.setState({ ShipFromcompName: event.target.value });
  };
  // shipfromhousechanged = (event) => {
  //   this.setState({ ShipFromhouseStreet: event.target.value });
  // }
  AddressLinechanged = (event) => {
    this.setState({ shipfromAddressValue: event.target.value });
  };
  shipfromcityChanged = (event) => {
    this.setState({ shipFromCityValue: event.target.value });
  };

  fromZipCodeChanged = (event) => {
    this.setState({ FromZipCode: event.target.value });
  };

  bpidchanged = (event) => {
    this.setState({ FrombpID: event.target.value });
  };
  FromContactChanged = (event) => {
    this.setState({ FromContactName: event.target.value });
  };
  fromShipPhponeChanged = (event) => {
    let FromShipPhone = event.target.value;
    FromShipPhone = FromShipPhone.replace(/[^0-9]/gi, "");
    this.setState({ FromShipPhone });
  };

  FromadditionalInfoChanged = (event) => {
    this.setState({ FromadditionInfo: event.target.value });
  };

  TolocationChanged = (event) => {
    this.setState({ ToLocationId: event.target.value });
  };

  TocompanyChanged = (event) => {
    this.setState({ ToCompanyname: event.target.value });
  };

  // ToHouseChanged = (event) => {
  //   this.setState({ To_housestreet: event.target.value });
  // }

  ToAddressChanged = (event) => {
    this.setState({ ToAddressline: event.target.value });
  };

  ToZipChanged = (event) => {
    this.setState({ ToZipvalue: event.target.value });
  };

  /*********To************** */

  ToBpchanged = (event) => {
    this.setState({ ToBpIdValue: event.target.value });
  };
  ToContactchanged = (event) => {
    this.setState({ ToContactName: event.target.value });
  };
  TophoneChanged = (event) => {
    let ToPhoneNumber = event.target.value;
    ToPhoneNumber = ToPhoneNumber.replace(/[^0-9]/gi, "");
    this.setState({ ToPhoneNumber });
  };

  toEmailChanged = (event) => {
    this.setState({ ToEmail: event.target.value });
  };
  toaddinfochanged = (event) => {
    this.setState({ toAdd_info: event.target.value });
  };

  brokeremailchanged = (event) => {
    this.setState({ brokeremailvalue: event.target.value });
  };
  brokerphonenumberchanged = (event) => {
    let brokerPhonenumbervalue = event.target.value;
    brokerPhonenumbervalue = brokerPhonenumbervalue.replace(/[^0-9]/gi, "");
    this.setState({ brokerPhonenumbervalue });
  };
  brokerContactnamechanged = (event) => {
    this.setState({ brokerNameValue: event.target.value });
  };
  brokerchanged = (event) => {
    this.setState({ brokerValue: event.target.value });
  };
  RqpickupChanged = (event) => {
    this.setState({ ReqPickupDate: event.value });
    var datepikcerValidate = this.PickUpValidation(event.value);
    
    this.setState({ DateChanged: datepikcerValidate });
  };

  RqdeliveryChanged = (event) => {
    this.setState({ ReqDeliveryDate: event.value });

    this.deliveryDateValidation(event.value);
  };

  deliveryDateValidation(values) {
    var deliveryDate = new Date(values);

    var ToMonth = deliveryDate.getMonth() + 1;
    var ToDay = deliveryDate.getDate();
    var ToYear = deliveryDate.getFullYear();

    if (ToDay <= 9) ToDay = "0" + ToDay;
    if (ToMonth < 10) ToMonth = "0" + ToMonth;
    var ToDate = "" + ToYear + ToMonth + ToDay;
    console.log("todate", ToDate);
    console.log("" + ToYear + ToMonth + ToDay )

    if (this.state.fromdateSelect <= ToDate) {
      return true;
    } else {
      toast.error(
        "Requested Delivery Date should be greater than Requested Pick Up Date"
      );
    }
  }

  changeTPT(values) {
    const re = /^[0-9\b]+$/;
    //if (e.target.value === '' || re.test(e.target.value)) {
    //   this.setState({value: e.target.value})
    //}

    if (parseInt(values) > 99) {
      values = "";
      toast.error("TPT cannot be greater than 99", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
    } else if (values === "" || re.test(values)) {
      return;
    } else {
      toast.error("Please enter valid TPT", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
    }
  }



  tptchanged = (event) => {
    this.setState({ tptValue: event.target.value });
    const tptValues = event.target.value;
    this.changeTPT(tptValues);
  };

  shiplocationChanged = (event) => {
    this.setState({ Shiplocationvalue: event.target.value });
  };

  referenceChanged = (event) => {
    this.setState({ intelrefnum: event.target.value });
  };

  specialinstructChanged = (event) => {
    this.setState({ specialinstruct: event.target.value });
  };

  ServiceDocchanged = (event) => {
    this.setState({ DocTypeValue: event.target.value });
  };
  commChanged = (event) => {
    this.setState({ CommodityValue: event.target.value });
  };

  transportChanged = (event) => {
    this.setState({ TransportationValue: event.target.value });
  };
  fromShipemailIdChanged = (event) => {    
    this.setState({ FromShipEmailId: event.target.value });
  };

  Validate_generalInformation(ctrue) {
    if (ctrue == true) {
      if (this.state.Tor_Type != "ZMSB") {
        if (
          this.state.ParentScacCode.value == null ||
          this.state.ParentScacCode.value == "" ||
          this.state.ParentScacCode.value == "undefined"
        ) {
          toast.error("Please select carrier code", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });
          return;
        }
      }

      if (
        this.state.reasoncodeValue.value == null ||
        this.state.reasoncodeValue.value == "" ||
        this.state.reasoncodeValue.value == "undefined"
      ) {
        toast.error("Please select Reason code", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.userID == null ||
        this.state.userID == "" ||
        this.state.userID == "undefined"
      ) {
        toast.error("Please user ID", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.ResPhonenumber == null ||
        this.state.ResPhonenumber == "" ||
        this.state.ResPhonenumber == "undefined"
      ) {
        toast.error("Please enter Phone number", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (this.state.ResPhonenumber.length > 30) {
        toast.error("Phone number cannot be greater than 15 characters", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.userEmail == null ||
        this.state.userEmail == "" ||
        this.state.userEmail == "undefined"
      ) {
        toast.error("Please enter Email", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.ShipFromcompName == null ||
        this.state.ShipFromcompName == ""
      ) {
        toast.error("Please enter from company name", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      //Check for length
      if (this.state.ShipFromcompName.length > 80) {
        toast.error("company name cannot be more than 60 characters", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      // if ((this.state.ShipFromhouseStreet == null) || this.state.ShipFromhouseStreet == '') {
      //   toast.error("Please enter from house.no and street address", {
      //     position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true,
      //     pauseOnHover: true, draggable: true, progress: undefined
      //   });
      //   return;
      // }

      if (
        this.state.shipfromAddressValue == null ||
        this.state.shipfromAddressValue == ""
      ) {
        toast.error("Please enter from Address line detail", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      // //Address line length
      if (this.state.shipfromAddressValue.length > 240) {
        //increased address length to 240 from 60 on 3/13/2019
        toast.error("Address Cannot be greater than 240 characters", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.shipFromCityValue == null ||
        this.state.shipFromCityValue == ""
      ) {
        toast.error("Please enter from city name", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (this.state.shipFromCityValue.length > 40) {
        toast.error("City cannot be greater than 40 characters", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.FromCountryValue.value == null ||
        this.state.FromCountryValue.value == "" ||
        this.state.FromCountryValue.value == "undefined"
      ) {
        toast.error("Please select from Country", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.fromRegionValue.value == null ||
        this.state.fromRegionValue.value == "" ||
        this.state.fromRegionValue.value == "undefined"
      ) {
        toast.error("Please select from Region", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.FromPortValue.value == null ||
        this.state.FromPortValue.value == "" ||
        this.state.FromPortValue.value == "undefined"
      ) {
        toast.error("Please select from Port", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.FromZipCode == null ||
        this.state.FromZipCode == "" ||
        this.state.FromZipCode == "undefined"
      ) {
        toast.error("Please enter from Zipcode", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (this.state.FromZipCode.length > 10) {
        toast.error("Postal code cannot be greater than 10 characters", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.FromContactName == null ||
        this.state.FromContactName == "" ||
        this.state.FromContactName == "undefined"
      ) {
        toast.error("Please enter from Contact Name", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.FromShipPhone == null ||
        this.state.FromShipPhone == "" ||
        this.state.FromShipPhone == "undefined"
      ) {
        toast.error("Please enter from Phone number", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (this.state.FromShipPhone.length > 30) {
        toast.error("Phone number cannot be greater than 30 characters", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.FromShipEmailId == null ||
        this.state.FromShipEmailId == "" ||
        this.state.FromShipEmailId == "undefined"
      ) {
        toast.error("Please enter from contact Email", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      //   if(this.state.FromadditionInfo==null || this.state.FromadditionInfo=="" || this.state.FromadditionInfo=="undefined"){

      //     toast.error("Please enter from Additional Information", {position: "top-right",autoClose: 5000,hideProgressBar: false,closeOnClick: true,
      //     pauseOnHover: true,draggable: true,progress: undefined});
      //  return;
      //   }

      if (
         this.isValidEmail(this.state.FromShipEmailId)
      ) {
        // toast.error("Please enter from contact Email", {position: "top-right",autoClose: 5000,hideProgressBar: false,closeOnClick: true,
        // pauseOnHover: true,draggable: true,progress: undefined});
        //return true;
      } else {
        toast.error("Ship From contact mail doesnot contain @ or .", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      // }
      //   return "success";
      // }

      // ToAddressMandatoryCheck(ctrue) {

      //   if(ctrue==true){
      if (this.state.ToCompanyname == null || this.state.ToCompanyname == "") {
        toast.error("Please enter To company name", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      //Check for length
      if (this.state.ToCompanyname.length > 80) {
        toast.error("company name cannot be more than 60 characters", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      // if ((this.state.To_housestreet == null) || this.state.To_housestreet == '') {
      //   toast.error("Please enter To house.no and street address", {
      //     position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true,
      //     pauseOnHover: true, draggable: true, progress: undefined
      //   });
      //   return;
      // }

      if (this.state.ToAddressline == null || this.state.ToAddressline == "") {
        toast.error("Please enter To Address line detail", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      // //Address line length
      if (this.state.ToAddressline.length > 240) {
        //increased address length to 240 from 60 on 3/13/2019
        toast.error("Address Cannot be greater than 240 characters", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (this.state.TocityValue == null || this.state.TocityValue == "") {
        toast.error("Please enter To city name", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (this.state.TocityValue.length > 40) {
        toast.error("City cannot be greater than 40 characters", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.toCountryValue.value == null ||
        this.state.toCountryValue.value == "" ||
        this.state.toCountryValue.value == "undefined"
      ) {
        toast.error("Please select To Country", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.ToRegionValue.value == null ||
        this.state.ToRegionValue.value == "" ||
        this.state.ToRegionValue.value == "undefined"
      ) {
        toast.error("Please select To Region", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      //   if(this.state.ToportValue.value==null || this.state.FromPortValue.value=="" || this.state.FromPortValue.value=="undefined"){

      //     toast.error("Please select To Port", {position: "top-right",autoClose: 5000,hideProgressBar: false,closeOnClick: true,
      //     pauseOnHover: true,draggable: true,progress: undefined});
      // return;
      //   }

      if (
        this.state.ToportValue.value == null ||
        this.state.ToportValue.value == "" ||
        this.state.ToportValue.value == "undefined"
      ) {
        toast.error("Please select To Port", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.ToZipvalue == null ||
        this.state.ToZipvalue == "" ||
        this.state.ToZipvalue == "undefined"
      ) {
        toast.error("Please enter To Zipcode", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (this.state.ToZipvalue.length > 10) {
        toast.error("Postal code cannot be greater than 10 characters", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.ToContactName == null ||
        this.state.ToContactName == "" ||
        this.state.ToContactName == "undefined"
      ) {
        toast.error("Please enter To Contact Name", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.ToPhoneNumber == null ||
        this.state.ToPhoneNumber == "" ||
        this.state.ToPhoneNumber == "undefined"
      ) {
        toast.error("Please enter To Phone number", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (this.state.ToPhoneNumber.length > 30) {
        toast.error("Phone number cannot be greater than 30 characters", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.ToEmail == null ||
        this.state.ToEmail == "" ||
        this.state.ToEmail == "undefined"
      ) {
        toast.error("Please enter To contact Email", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      //  if(this.state.toAdd_info==null || this.state.toAdd_info=="" || this.state.toAdd_info=="undefined"){

      //    toast.error("Please enter To Additional Information", {position: "top-right",autoClose: 5000,hideProgressBar: false,closeOnClick: true,
      //    pauseOnHover: true,draggable: true,progress: undefined});
      // return;
      //  }

      if (
         this.isValidEmail(this.state.ToEmail)
      ) {
        // toast.error("Please enter from contact Email", {position: "top-right",autoClose: 5000,hideProgressBar: false,closeOnClick: true,
        // pauseOnHover: true,draggable: true,progress: undefined});
        //return;
      } else {
        toast.error("Ship To contact mail doesnot contain @ or .", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      /*********Date************ */

      if (
        this.state.ReqPickupDate == null ||
        this.state.ReqPickupDate == "" ||
        this.state.ReqPickupDate == "undefined"
      ) {
        toast.error("Please choose Pickup date", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.ReqDeliveryDate == null ||
        this.state.ReqDeliveryDate == "" ||
        this.state.ReqDeliveryDate == "undefined"
      ) {
        toast.error("Please choose Delivery date ", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.ServiceCodeValue.value == null ||
        this.state.ServiceCodeValue.value == "" ||
        this.state.ServiceCodeValue.value == "undefined"
      ) {
        toast.error("Please select Service Code", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (this.props.location.state.FGType !== true) {
        ;
        if (
          this.state.CommodityValue.value == null ||
          this.state.CommodityValue.value == "" ||
          this.state.CommodityValue.value == "undefined"
        ) {
          toast.error("Please select Commodity Code", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });
          return;
        }
      }

      if (
        this.state.TransportationValue.value == null ||
        this.state.TransportationValue.value == "" ||
        this.state.TransportationValue.value == "undefined"
      ) {
        toast.error("Please select Transportation Mode ", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.incotermValue.value == null ||
        this.state.incotermValue.value == "" ||
        this.state.incotermValue.value == "undefined"
      ) {
        toast.error("Please select Incoterms ", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.tptValue == null ||
        this.state.tptValue == "" ||
        this.state.tptValue == "undefined"
      ) {
        toast.error("Please enter TPT", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.incotermValue == null ||
        this.state.incotermValue == "" ||
        this.state.incotermValue == "undefined"
      ) {
        toast.error("Please enter Inconterms", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (
        this.state.Shiplocationvalue == null ||
        this.state.Shiplocationvalue == "" ||
        this.state.Shiplocationvalue == "undefined"
      ) {
        toast.error("Please enter location", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        return;
      }

      if (this.state.DocTypeValue.value != undefined) {
        if (
          this.state.intelrefnum == null ||
          this.state.intelrefnum == "" ||
          this.state.intelrefnum == "undefined"
        ) {
          toast.error("Please Enter Intel Reference Number", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });
          return;
        }
        
      }
    }
    return "success";
  }

  PickUpValidation(val) {
    var pickAction = val;
    var currDateObj = new Date();
    var stringCurrDate = currDateObj.toISOString();
    console.log(pickAction, currDateObj, stringCurrDate);
    var days = currDateObj - pickAction;
    // console.log("ddddd",days);

    var fromMonth = pickAction.getMonth() + 1;
    var fromDay = pickAction.getDate();
    var fromYear = pickAction.getFullYear();

    if (fromDay <= 9) fromDay = "0" + fromDay;
    if (fromMonth < 10) fromMonth = "0" + fromMonth;
    var fromDate = "" + fromYear + fromMonth + fromDay;
    this.state.fromdateSelect = fromDate;
    console.log("ffrmdate", fromDate);

    // var today = new Date();

    var data = new Date();
    var month = data.getMonth() + 1;
    var day = data.getDate();
    var year = data.getFullYear();
    if (day <= 9) day = "0" + day;
    if (month < 10) month = "0" + month;
    const todayFull = ""+ year + month + day;
    //console.log("postDate",todayFull);

    if (this.state.docValue.text == "Intel Shipment Request") {
      if (fromDate >= todayFull) {
      } else {
        toast.error(
          "Requested Pick Up Date should be greater than Current Date",{theme:"colored"}
        );
        this.setState({ ReqPickupDate: "" });
        return;
      }
    } else if (this.state.docValue.text == "Multi-Bid Request") {
      if (fromDate >= todayFull) {
      } else {
        toast.error(
          "Requested Pick Up Date should be greater than Current Date",{theme:"colored"}
        );
        this.setState({ ReqPickupDate: "" });
        return;
      }
    } else if (this.state.docValue.text == "Invoice Adjustment Request") {
      if (fromDate <= todayFull) {
      } else {
        toast.error("Requested Pick Up Date should be Past date",{theme:"colored"});
        this.setState({ ReqPickupDate: "" });
        return;
      }
    }

    return "success";
  }

  isValidEmail(email) {
    const eMailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return eMailPattern.test(email);
  };

  pickupvalidate() {
    if (this.state.ReqPickupDate != "") {
      var pickAction = this.state.ReqPickupDate;
      var currDateObj = new Date();
      var stringCurrDate = currDateObj.toISOString();
      console.log(pickAction, currDateObj, stringCurrDate);
      var days = currDateObj - pickAction;
      // console.log("ddddd",days);

      var fromMonth = pickAction.getMonth() + 1;
      var fromDay = pickAction.getDate();
      var fromYear = pickAction.getFullYear();

      if (fromDay <= 9) fromDay = "0" + fromDay;
      if (fromMonth < 10) fromMonth = "0" + fromMonth;
      var fromDate = "" + fromYear + fromMonth + fromDay;
      this.state.fromdateSelect = fromDate;
      console.log("ffrmdate", fromDate);

      // var today = new Date();

      var data = new Date();
      var month = data.getMonth() + 1;
      var day = data.getDate();
      var year = data.getFullYear();
      if (day <= 9) day = "0" + day;
      if (month < 10) month = "0" + month;
      const todayFull = "" + year + month + day;

      if (this.state.docValue.text == "Intel Shipment Request") {
        if (fromDate >= todayFull) {
        } else {
          toast.error(
            "Requested Pick Up Date should be greater than Current Date",{theme:"colored"}
          );
          //  this.setState({ ReqPickupDate:'' });
          return;
        }
      }

      if (this.state.docValue.text == "Multi-Bid Request") {
        if (fromDate >= todayFull) {
        } else {
          toast.error(
            "Requested Pick Up Date should be greater than Current Date",{theme:"colored"}
          );
          //this.setState({ ReqPickupDate:'' });
          return;
        }
      }

      if (this.state.docValue.text == "Invoice Adjustment Request") {
        if (fromDate <= todayFull) {
        } else {
          toast.error("Requested Pick Up Date should be Past date",{theme:"colored"});
          this.setState({ ReqPickupDate: "" });
          return;
        }
      }
    } else {
      // toast.error("Please Select Pick Date...");
      return;
    }

    if (this.state.ReqDeliveryDate != "") {
      var deliveryDate = this.state.ReqDeliveryDate;

      var ToMonth = deliveryDate.getMonth() + 1;
      var ToDay = deliveryDate.getDate();
      var ToYear = deliveryDate.getFullYear();

      if (ToDay <= 9) ToDay = "0" + ToDay;
      if (ToMonth < 10) ToMonth = "0" + ToMonth;
      var ToDate = "" + ToYear + ToMonth + ToDay;
      //console.log("todate",ToDate);

      if (this.state.fromdateSelect <= ToDate) {
      } else {
        toast.error(
          "Requested Delivery Date should be greater than Requested Pick Up Date",{theme:"colored"}
        );
        return;
      }
    } else {
      // toast.error("Please Select Delivery Date....");
      return;
    }

    return "success";
  }
  async FO_SaveData() {
    if (
      this.state.currentTab === "bid" ||
      (this.state.currentTab === "invoice" && this.state.Tor_Type === "ZEXC") ||
      (this.state.roleList["CW"] === "True" &&
        this.state.DOCSTATUSForProp == "10")
    ) {
      // CW - GB role user created data is Submited by BB role
      if (this.state.createdByUserRole !== 'CW') {
        if (
          this.state.EX_HEADER.CREATED_BY !== this.state.logginuserId &&
          this.state.DOCSTATUSForProp === "10"
        ) {
          toast.error("User doesn't have sufficient authorizations",{theme:"colored"});
          return;
        }
      }

      //Changed from file

      const isDataPresentinBidTable = JSON.parse(
        sessionStorage.getItem("isDataPresentinBidTable")
          ? sessionStorage.getItem("isDataPresentinBidTable")
          : "true"
      );

      if (!isDataPresentinBidTable) {
        toast.error("Please add fee code to submit");
        return;
      }

      // If Carrier user FO_SUBMIT directly
      if (
        this.state.roleList["CARRIER"] === "True" ||
        this.state.Tor_Type === "ZMSB" ||
        this.state.roleList["CW"] === "True"
      ) {
        const inputData = {
          tor_id: this.state.tor_id,
        };
        let InputJSONString = JSON.stringify(inputData);
        let props = {};
        let inputObjs = {};
        props["query"] = constants.serviceRoot;
        props["headers"] = constants.serviceHeaders;
        inputObjs["Activity"] = "FO_SUBMIT";
        inputObjs["Input"] = InputJSONString;
        props.input = inputObjs;
        const result = await GatewayGet(props, props.input);

        if (result["STATUS"] === "SUCCESS") {
          sessionStorage.setItem("tor_id", this.state.tor_id);
          toast.success("Request Submitted Successfully",{theme:"colored"});

          $("#customBox ul li.GDdisabled a").addClass("active");
          $(".tab-content #rate").addClass("active");
          $("button.submit-disable").addClass("menu-disable");

          $("a.Tab_item,#It_d").removeClass("active");
          $("a.Tab_bid,#Bid_d").removeClass("active");
          $("a.Tab_inv,#Inv_d").removeClass("active");

          $("#customBox ul li.Tab_item a").removeClass("active");
          $("#customBox ul li.Tab_bid a").removeClass("active");
          $("#customBox ul li.Tab_inv a").removeClass("active");

          if (this.state.Tor_Type === "ZMSB") {
            this.tenderingManagerRef.current.getReasonCodeData();
            this.tenderingManagerRef.current.searchTenderingData();
          }
          // redirect to request authorized
          this.props.navigate({
            pathname: `/intelshipment`,
          });
        } else if (result["STATUS"] === "FAILURE") {
          var msg = "";

          if (result["MESSAGE"][1].TYPE == "E") {
            msg = result["MESSAGE"][1].MESSAGE;

            toast.error(msg, {
              position: "top-right",

              autoClose: 5000,

              hideProgressBar: false,

              closeOnClick: true,

              pauseOnHover: true,

              draggable: true,

       progress: undefined,
        theme:"colored"            });
          }
        }
      }

      // Else BB user
      if (
        this.state.roleList["BB"] === "True" &&
        this.state.Tor_Type != "ZMSB"
      ) {
        // BB User Fo_Submit

        // redirect to request authorized
        this.props.navigate(`/RequestAuthorized/:${sessionStorage.getItem("tor_id")}`,{ state: {
          parentscac: this.state.ParentScacCode,
          tor_type: this.state.Tor_Type,
          scacAbb: this.state.abbvalue,
        } })

       
      }
      this.setState({ blocking: false });
    } else {
      //Check for transportation mode if it is selected as "99"
      if(this.state.TransportationValue.value == "99")
      {
        toast.error("Please select a valid Transportation Mode",{theme:"colored"});
        this.setState({ blocking: false });
        return;
      }
      var PickUpDateSuccess = this.pickupvalidate();
      var Validation_Gnform = this.Validate_generalInformation(true);

      if (Validation_Gnform == "success" && PickUpDateSuccess == "success") {
        this.setState({ blocking: true });
        //      var bp = [];

        if (
          this.state.roleList["CARRIER"] == "True" ||
          this.state.roleList["CW"] == "True"
        ) {
          if (
            this.state.tobeauthorValue == null ||
            this.state.tobeauthorValue == "" ||
            this.state.tobeauthorValue == undefined
          ) {
            // var toBeAuth = this.state.tobeauthorValue;
           
            // this.state.authlist = [];
            // for (var i = 0; i < toBeAuth.length; i++) {
            //   var tbAuth = {};
            //   tbAuth["PARTY_RCO"] = "TM201";
            //   tbAuth["PARTY_ID"] = toBeAuth[i].idsid;
            //   this.state.authlist.push(tbAuth);
            // }

            // if (this.state.authlist.length > 5) {
            //   toast.error("Select Max upto 5 Authorizer");
            //   return;
            // } else {
            //   var bp = this.state.authlist;
            // }
            var bp = [];
            toast.error("Please select Atleast 1 Authorizer");
            this.setState({blocking : false});
            return;
          
        }
         else {
          // var bp = [];

          var toBeAuth = this.state.tobeauthorValue;
           
          this.state.authlist = [];
          for (var i = 0; i < toBeAuth.length; i++) {
            var tbAuth = {};
            tbAuth["PARTY_RCO"] = "TM201";
            tbAuth["PARTY_ID"] = toBeAuth[i].idsid;
            this.state.authlist.push(tbAuth);
          }

          if (this.state.authlist.length > 5) {
            toast.error("Select Max upto 5 Authorizer");
            return;
          } else {
            var bp = this.state.authlist;
          }
        }
      }

        if (this.state.intelrefnum != null) {
          var imDocRefArr = [];
          var refLineNumArr = this.state.intelrefnum;
          //Logic to build multiple doc ref
          // for (var i = 0; i < refLineNumArr.length; i++) {

          var node = {
            btdTco: this.state.DocTypeValue.value,
            btdId: refLineNumArr,
            BTDITEM_TCO: "",
            BTDITEM_ID: "",
          };

          imDocRefArr.push(node);
        } else {
          var imDocRefArr = "";
        }

        var fromport = this.state.FromPortValue.text;
        // var frmprt = fromport.split("-")[1];
         var frmprt = fromport;
        var toport = this.state.ToportValue.text;
        // var toPortVal = toport.split("-")[1];
        var toPortVal = toport;
        //+ this.state.ShipFromhouseStreet
        var fromAddress = this.state.shipfromAddressValue;
        var toAddress = this.state.ToAddressline;
        var fullFromAddress =
          "CompanyName:" +
          this.state.ShipFromcompName +
          "¡" +
          "Address:" +
          fromAddress +
          "¡" +
          "Country:" +
          this.state.FromCountryValue.text +
          "¡" +
          "Region:" +
          this.state.fromRegionValue.text +
          "¡" +
          "Port:" +
          frmprt +
          "¡" +
          "City:" +
          this.state.shipFromCityValue +
          "¡" +
          "Zip:" +
          this.state.FromZipCode +
          "¡" +
          "ContactName:" +
          this.state.FromContactName +
          "¡" +
          "ContactPhNo:" +
          this.state.FromShipPhone +
          "¡" +
          "ContactEmail:" +
          this.state.FromShipEmailId;

        var fullToAddress =
          "CompanyName:" +
          this.state.ToCompanyname +
          "¡" +
          "Address:" +
          toAddress +
          "¡" +
          "Country:" +
          this.state.toCountryValue.text +
          "¡" +
          "Region:" +
          this.state.ToRegionValue.text +
          "¡" +
          "Port:" +
          toPortVal +
          "¡" +
          "City:" +
          this.state.TocityValue +
          "¡" +
          "Zip:" +
          this.state.ToZipvalue +
          "¡" +
          "ContactName:" +
          this.state.ToContactName +
          "¡" +
          "ContactPhNo:" +
          this.state.ToPhoneNumber +
          "¡" +
          "ContactEmail:" +
          this.state.ToEmail;

        var sourceLoc = "",
          destLoc = "";
         
          
         
         
        console.log("fromPort", fromPort);
        if (this.props.location.state.isNew == true) {
          var fromPort = this.state.FromPortValue.value;
          // this.state.this.state.some(elem => elem.name === fromPort
          if (fromPort.substring(0, 2) == "P_")
            sourceLoc = "PORT_" + fromPort.substring(2, fromPort.length);
          else sourceLoc = "PORT_" + fromPort;

          var toPort = this.state.ToportValue.value;
          if (toPort.substring(0, 2) == "P_")
            destLoc = "PORT_" + toPort.substring(2, toPort.length);
          else destLoc = "PORT_" + toPort;
        } else {
          if(this.state.FromPortValue.text.includes('-'))
          {
          var fromPort = this.state.FromPortValue.value;
          if (fromPort.substring(0, 2) == "P_")
            // sourceLoc = "PORT_" + fromPort.split("-")[0];
            sourceLoc = "PORT_" + fromPort;
          else 
          // sourceLoc = "PORT_" + fromPort.split("-")[0];
          sourceLoc = "PORT_" + fromPort;
          }

          // var toPort = this.state.ToportValue.value;
          // if (toPort.substring(0, 2) == "P_")
          //   // destLoc = "PORT_" + toPort.split("-")[0];
          //   destLoc = "PORT_" + toPort
          // else 
          // // destLoc = "PORT_" + toPort.split("-")[0];
          // destLoc = "PORT_" + toPort
          // }

          else
          {
            
            for(var i=0;i<this.state.FromPortData.length;i++)
          {
            if(this.state.FromPortData[i].text.split('-')[1] === this.state.FromPortValue.value )
            {
               sourceLoc = "PORT_" + this.state.FromPortData[i].value;
            }
          }
        }

        if(this.state.ToportValue.text.includes('-'))
        {
          var toPort = this.state.ToportValue.value;
          if (toPort.substring(0, 2) == "P_")
            // destLoc = "PORT_" + toPort.split("-")[0];
            destLoc = "PORT_" + toPort
          else 
          // destLoc = "PORT_" + toPort.split("-")[0];
          destLoc = "PORT_" + toPort
          
        }
        else{

          for(var i=0;i<this.state.ToPortData.length;i++)
          {
            if(this.state.ToPortData[i].text.split('-')[1] === this.state.ToportValue.value )
            {
              destLoc = "PORT_" + this.state.ToPortData[i].value;
            }
          }
        }
          
        }

        var pickupDateObj = this.state.ReqPickupDate;
        var fromMonth = pickupDateObj.getMonth() + 1;
        var fromDay = pickupDateObj.getDate();
        var fromYear = pickupDateObj.getFullYear();
        

        if (fromDay <= 9) fromDay = "0" + fromDay;
        if (fromMonth < 10) fromMonth = "0" + fromMonth;

        var fromTime = kendo.toString(pickupDateObj, 'HH:mm:ss');
    console.log(fromTime);

        // if (fromMonth.length < 2) fromMonth = '0' + fromMonth;
        // if (fromDay.length < 2) fromDay = '0' + fromDay;

        var fromDate = fromMonth + "/" + fromDay + "/" + fromYear + " "+fromTime;

        var todeliveryDate = this.state.ReqDeliveryDate;
        var ToMonth = todeliveryDate.getMonth() + 1;
        var ToDay = todeliveryDate.getDate();
        var ToYear = todeliveryDate.getFullYear();

        

        if (ToDay <= 9) ToDay = "0" + ToDay;
        if (ToMonth < 10) ToMonth = "0" + ToMonth;
        var toTime = kendo.toString(todeliveryDate, 'HH:mm:ss');
        var ToDate = ToMonth + "/" + ToDay + "/" + ToYear+" "+toTime;

        if (this.state.Tor_Type == "ZMSB") {
          this.setState({abbvalue : ""});
          this.state.ParentScacCode.text = "";
        }

        // code added to remove Amsterdam from PORT_AMS-Amsterdam in sourcelocation and destinationlocation
        sourceLoc = sourceLoc.includes('-') ? sourceLoc.split('-')[0] : sourceLoc;
        destLoc = destLoc.includes('-') ? destLoc.split('-')[0] : destLoc;

        var inputData = {
          IM_HEADER: {
            //"TOR_ID": this.state.Tor_idnum,//"00000000002000000485",
            sourcelocation: sourceLoc, //"9100000642",
            destinationlocation: destLoc, //"9100000641",
            yccode: this.state.CommodityValue.value, //"YCo",
            TRMODCOD: this.state.TransportationValue.value, //Mode of transport
            YNCRM_REASON_CODE: this.state.reasoncodeValue.value, //"99", Check with eshwar
            YTPT: this.state.tptValue, //"1",
            PLANNED_SHIPMENT_START: fromDate + " " + "00:00:00", //"09022018 14:00:00",
            PLANNED_SHIPMENT_END: ToDate + " " + "00:00:00", //"10022018 14:00:00",
            YMOV_TYPE: this.state.ServiceCodeValue.value, //Check With Seena, service code
            INC_CLASS_CODE: this.state.incotermValue.value, //Check with Seena, incoterm
            INC_TRANSF_LOC_N: this.state.Shiplocationvalue,
            TSPID: this.state.abbvalue, //Check with Seena (single bid and inv adj carrier) -> Bid Detaisl
            TSP_SCAC: this.state.ParentScacCode.text,
            //"YTOR_DOCSTATUS": this.state.FO_status//Check with Seena
          },

          IM_NOTES: [
            {
              textType: "ZBRO",
              text: this.state.brokerValue ? this.state.brokerValue : "",
            },
            {
              textType: "ZBRN",
              text: this.state.brokerNameValue
                ? this.state.brokerNameValue
                : "",
            },
            {
              textType: "ZBRE",
              text: this.state.brokeremailvalue
                ? this.state.brokeremailvalue
                : "",
            },
            {
              textType: "ZBRP",
              text: this.state.brokerPhonenumbervalue
                ? this.state.brokerPhonenumbervalue
                : "",
            },
            {
              textType: "ZNRC",
              text: this.state.ncrmcommentvalue
                ? this.state.ncrmcommentvalue
                : "",
            },
            {
              textType: "ZSIR",
              text: this.state.specialinstruct
                ? this.state.specialinstruct
                : "",
            },
            {
              textType: "ZREP",
              text: this.state.ResPhonenumber ? this.state.ResPhonenumber : "",
            },
            {
              textType: "ZSRC",
              text: fullFromAddress,
            },
            {
              textType: "ZDES",
              text: fullToAddress,
            },
          ],

          IM_DOCREF: imDocRefArr,
          IM_BP: bp,
        };

        console.log("inputData", JSON.stringify(inputData));

        if (this.state.docValue.text == "Intel Shipment Request") {
          this.setState({ blocking: true });
          if (this.props.location.state.isNew == true) {
            this.GatewayServiceFunctionSaveFO("FO_HEADER_CREATE_SB", inputData);
          } else {
            inputData["IM_HEADER"]["TOR_ID"] = this.state.tor_id;
            this.GatewayServiceFunctionSaveFO("FO_HEADER_UPDATE_SB", inputData);
          }
        } else if (this.state.docValue.text == "Multi-Bid Request") {
          this.setState({ blocking: true });
          if (this.props.location.state.isNew == true) {
            this.GatewayServiceFunctionSaveFO("FO_HEADER_CREATE_MB", inputData);
          } else {
            inputData["IM_HEADER"]["TOR_ID"] = this.state.tor_id;
            this.GatewayServiceFunctionSaveFO("FO_HEADER_UPDATE_MB", inputData);
          }
        } else if (this.state.docValue.text == "Invoice Adjustment Request") {
          this.setState({ blocking: true });
          if (this.props.location.state.isNew == true) {
            this.GatewayServiceFunctionSaveFO(
              "FO_HEADER_CREATE_INVA",
              inputData
            );
          } else {
            inputData["IM_HEADER"]["TOR_ID"] = this.state.tor_id;
            this.GatewayServiceFunctionSaveFO(
              "FO_HEADER_UPDATE_INVA",
              inputData
            );
          }
        }
      } else {
        return false;
      }
    }
  }

  async GatewayServiceFunctionSaveFO(activityName, inputData) {
    const jsonResponse = await tmscall.commonFoCreateUpdate(
      activityName,
      inputData
    );

    if (jsonResponse.STATUS == "SUCCESS") {
      sessionStorage.setItem("tor_id", jsonResponse.TOR_ID);

      this.setState({ tor_id: jsonResponse.TOR_ID });

      this.setState({ saveClicked: true });

      if (this.props.location.state.isNew == true) {
        $("#itemdiv").css("display", "block");
        $("button.Save-disable").addClass("menu-disable");
      }

      $("#customBox ul li.GDdisabled,#rate").removeClass("active");
      if (this.state.Tor_Type == "ZEXC")
        $("a.Tab_item,a.Tab_inv,a.Tab_status").removeClass("menu-disable");
      else $("a.Tab_item,a.Tab_bid,a.Tab_status").removeClass("menu-disable");
      // change made
      $("a.Tab_item,#It_d").addClass("active");
      $("#customBox ul li.Tab_item a").addClass("active");
      $("#customBox ul li.Tab_status a").addClass("active");
      $("#customBox ul li.GDdisabled a").removeClass("active");
      $("button.Save-disable").addClass("menu-disable");
      this.setState({ blocking: false });
      toast.success(
        jsonResponse.TOR_ID.substr(10, 10) + " " + "Request Saved Successfully",{theme:"colored"}
      );
      if (this.state.Tor_Type == "ZMSB") {
        toast.warning(
          "Please Submit the Request after Entering the Material Details to Create RFQ",{theme:"colored"}
        );
      }

      this.Fo_display_data(jsonResponse.TOR_ID, this.state.Tor_Type);
    } else if (
      jsonResponse.STATUS == "FAILURE" &&
      typeof jsonResponse.TOR_ID == "undefined" &&
      jsonResponse.TOR_ID != ""
    ) {
      toast.error("Failed to save Request");
      window.location.href="/NCRMHome";

    } else {
      var genericmsg = "Failed to save Request";
      toast.error(jsonResponse, genericmsg);
    }
//FO Copy tab refresh
    // if (this.state.copyTabRefresh) {
    //   this.itemDetailsRef.current.onFoCopyResetPage();
    //   this.setState({copyTabRefresh: false})
    // }
if (this.state.copyTabRefresh && this.itemDetailsRef.current) {
  this.itemDetailsRef.current.onFoCopyResetPage();
  this.setState({ copyTabRefresh: false });
}
    if (this.state.editTabRefresh && this.itemDetailsRef.current) {
      
      this.itemDetailsRef.current.Display_ItemDetail();
      this.itemDetailsRef.current.productRefresh();
      this.setState({editTabRefresh: false})
    }

  }

  TocityChanged = (event) => {
    this.setState({ TocityValue: event.target.value });
  };

  // FO_ClearData = () => {
  //   //this.setState({blocking:true});
  //   this.setState(this.baseState);
  //   this.componentDidMount();

  //   //this.setState({blocking:false});
  // }

  itemdetail(tabName) {
    if (tabName === "itemDetails") {
      this.setState({ currentTab: "itemDetails", saveClicked: true });
    }
    this.setState({ blocking: true });

    // this.tabChanged("itemDetails");
    toast.dismiss();
    setTimeout(() => {
      this.setState({ blocking: false });
    }, 3000);
  }

  generalDetail() {
    this.tabChanged("generalDetails");
    toast.dismiss();
    this.setState({ blocking: true });
    setTimeout(() => {
      this.setState({ blocking: false });
    }, 3000);
  }

  componentWillUnmount() {
    sessionStorage.removeItem("tor_id");
    sessionStorage.removeItem("DOCSTATUS");
    sessionStorage.removeItem("RequestMethodType");
  }

  cancelFO() {
    // if(this.state.HeaderCreateByUser==this.state.logginuserId){

    //   this.setState({FOCancelcontent:true});

    // }else{

    //     toast.error("User does not have sufficient authorization");

    // }
    this.setState({ FOCancelcontent: true });
  }

  FoCancel() {
    this.setState({ FOCancelcontent: false });
  }

  FOCancelConfirm() {
    var inputData = { tor_id: this.state.tor_id };

    if (this.state.docValue.text == "Multi-Bid Request") {
      this.GatewayServiceFunctionStopTendering(inputData);
    } else {
      this.GatewayServiceFunctionSubmitCancelFO(inputData);
    }
  }

  async GatewayServiceFunctionStopTendering(inputData) {
    //  var activityName = "FO_STOP_TENDERING";
    this.setState({ blocking: true });

    var result = await ServiceCall.StopTendering(inputData);

    if (result.STATUS == "SUCCESS")
      this.GatewayServiceFunctionSubmitCancelFO("FO_CANCEL", inputData);
    else toast.error("Stop Tendering failed");
  }

  async GatewayServiceFunctionSubmitCancelFO(inputData) {
    this.setState({ blocking: true, FOCancelcontent: false });
    var result = await ServiceCall.FO_CANCEL_DATA(inputData);
    console.log("Delete", result);

    if (result.STATUS == "SUCCESS") {
      toast.success("FO Cancelled Successfully",{ theme:"colored"  });
      this.Fo_display_data(this.state.tor_id, this.state.Tor_Type);

      
      $("#customBox ul li.GDdisabled,.tab-content #rate").addClass("active");
      $(
        "button.Save-disable,button.copy-disable,button.Edit-disable,button.can_disable"
      ).addClass("menu-disable");
    } else if (result.STATUS == "FAILURE") {
      toast.error("FO Cancellation Failed !!!",{ theme:"colored"  });
      $("#customBox ul li.GDdisabled,.tab-content #rate").addClass("active");
    }

    this.setState({ blocking: false });
  }

  editingFinished() {
    this.setState({ isEditClicked: false });
  }

  saveInvoiceDetailInputsOnSubmit(invoiceInputs) {
    console.log(invoiceInputs);
    this.setState({ invoiceDetailInputsOnSubmit: invoiceInputs });
  }

  tabChanged(tabName) {
    // this.setState({isEditClicked: false});

    if (tabName === "generalDetails") {
      this.setState({ currentTab: "generalDetails" });
    } else if (tabName === "bid") {
      this.setState({ currentTab: "bid" });
    } else if (tabName === "invoice") {
      this.setState({ currentTab: "invoice" });

      if (this.state.DOCSTATUSForProp < "10" || this.props.location.state.isNew == true) {
        $("button.Save-disable").removeClass("menu-disable");
        this.setState({ savebtnDisabled: false });
      } else {
        $("button.Save-disable").addClass("menu-disable");
        this.setState({ savebtnDisabled: true });
      }
    } else if (tabName === "itemDetails") {
      this.setState({
        currentTab: "itemDetails",
        saveClicked: true,
        isEditClicked: true,
      });
    } else if (tabName === "status") {
      if ($(".Tab_status").hasClass("active") == true) {
        if (this.state.DOCSTATUSForProp < "10" || this.props.location.state.isNew == true) {
          $("button.Save-disable").removeClass("menu-disable");
          this.setState({ savebtnDisabled: false });
        } else {
          $("button.Save-disable").addClass("menu-disable");
          this.setState({ savebtnDisabled: true });
        }
      }

      this.setState({ currentTab: "status" });
    }
  }

  bidSaved() {
    this.setState({ isBidSaved: true });
  }

  disableSubmit() {
    let profile1 = JSON.parse(sessionStorage.getItem("profile"));
    const userRole = profile1["ROLE_LIST"];
    if (
      userRole["CW"] == "True" &&
      this.state.DOCSTATUSForProp === "10" &&
      this.state.Tor_Type === "ZSSB"
    )
      return false;
    if (this.state.DOCSTATUSForProp !== "10") {
      return true;
    }
    if (!this.state.isBidSaved && this.state.Tor_Type != "ZMSB") {
      return true;
    }

    if (this.state.DOCSTATUSForProp == "10" && this.state.Tor_Type === "ZMSB") {
      return false;
    }

    return false;
  }




  authorizerfilterChange = (event) => {
    this.setState({
      authorization: this.filterauthData(event.filter)
    });
}

filterauthData(filter) {
    const data = this.state.authFilterData.slice();
    return filterBy(data, filter);
}

  render() {
    const { myDate } = this.state;
    const planningOrg = this.state.planningOrg.value;
    let profile1 = JSON.parse(sessionStorage.getItem("profile"));
    const userRole = profile1["ROLE_LIST"];
     console.log(this.state.docValue);

    return (
      <div>
        
        <BlockUi tag="div" blocking={this.state.blocking}
        
        loader={<Loaders />}>

          {this.state.FOCancelcontent && (
            <Dialog title={"Are you sure?"} onClose={this.FoCancel.bind(this)}>
              <p style={{ margin: "25px", textAlign: "center",color:"black" }}>
                Click Proceed to cancel Request or click cancel to go back
              </p>
              <DialogActionsBar>
                <button
                  className="btn k-button k-button-icontext rejectbtn"
                  onClick={this.FoCancel.bind(this)}
                >
                  Cancel
                </button>
                <button
                  className="btn k-button k-button-icontext"
                  onClick={this.FOCancelConfirm.bind(this)}
                >
                  Confirm
                </button>
              </DialogActionsBar>
            </Dialog>
          )}

          <MDBContainer fluid className="wrkarea">
            <MDBRow>
              <MDBCol sm="12" className="titleBox">
                <label>{this.state.docValue.text}</label>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
          <MDBContainer fluid className="box-contents">
            <MDBRow>
              <MDBCol sm="12">
                <table className="table cust">
                  <tr>
                    <td style={{ textAlign: "left" }}>
                      <DropDownList
                        data={this.state.documentData}
                        value={this.state.docValue}
                        style={this.state.error_select_doc_type ? { width: "222px", border: "red solid 3px" } : { width: "222px" } }
                        onChange={this.DocumentTypeChanged}
                        dataItemKey="FOType"
                        disabled={this.state.docDisabled}
                        filterable={true}
                        textField="text"
                      >
                        {" "}
                      </DropDownList>
                      {
                        <span className="Fonum">
                          {this.state.bindtextAndId}
                        </span>
                      }
                    </td>

                    <td>{/* <div>{myDate}</div> */}</td>
                    <td className="docVersion">
                      Document version: {this.state.documentVersion}
                    </td>
                  </tr>
                </table>
              </MDBCol>
            </MDBRow>
       
            <MDBRow>
              <MDBCol sm="12">
                <div className="sticky">
                  <img
                    src={back}
                    alt="back"
                    className="ddmo"
                    onClick={this.backClick.bind(this)}
                  />

                  <i className="intelicon-arrow-back-left"></i>

                  {/* <button className="btn k-button k-button-icontext reset-disable" onClick={this.FO_ClearData}>Reset</button> */}

                  {/* new code  */}

                  {this.state.currentTab === "bid" ||
                  (this.state.currentTab === "invoice" &&
                    this.state.Tor_Type === "ZEXC") ||
                  (userRole.CW === "True" &&
                    (this.state.DOCSTATUSForProp >= "10" ||
                      this.props.location.state.isNew === false)) ? (
                    <button
                      className="btn k-button k-button-icontext submit-disable"
                      // disabled={!this.state.isBidSaved}
                      disabled={this.disableSubmit()}
                      onClick={this.FO_SaveData.bind(this)}
                    >
                      Submit
                    </button>
                  ) : (
                    <button
                      className="btn k-button k-button-icontext Save-disable"
                      disabled={this.state.savebtnDisabled}
                      onClick={this.FO_SaveData.bind(this)}
                    >
                      Save
                    </button>
                  )}

                  <button
                    className="btn k-button k-button-icontext Edit-disable"
                   disabled={this.state.EditbtnDisabled}
                    onClick={this.FO_EnableEdit.bind(this)}
                  >
                    Edit
                  </button>
                  {/* <button className="btn k-button k-button-icontext">Display</button> */}
                  {userRole.CW === "False" && (
                    <button
                      className="btn k-button k-button-icontext copy-disable"
                      onClick={this.FO_Copy.bind(this)}
                    >
                      Copy
                    </button>
                  )}
                  <button
                    className="btn k-button k-button-icontext can_disable rejectbtn"
                    disabled={this.state.CancelbtnDisabled}
                    onClick={this.cancelFO.bind(this)}
                  >
                    Cancel
                  </button>
                </div>

                <div id="customBox">
                  <ul className="nav nav-tabs">
                    <li className="GDdisabled">
                      <a
                        data-toggle="tab"
                        href="#rate"
                        className="active"
                        onClick={this.generalDetail.bind(this)}
                      >
                        General Details
                      </a>
                    </li>
                    <li className="">
                      <a
                        data-toggle="tab"
                        className="Tab_item"
                        href="#It_d"
                        onClick={() => {
                          this.itemdetail("itemDetails");
                        }}
                      >
                        Item Details
                      </a>
                    </li>

                    <li hidden={this.state.isBidHiden} className="">
                      <a
                        data-toggle="tab"
                        href="#Bid_d"
                        className="Tab_bid"
                        onClick={() => {
                          this.tabChanged("bid");
                        }}
                      >
                        Bid Details
                      </a>
                    </li>
                    <li hidden={this.state.isInvoiceHiden} className="">
                      <a
                        data-toggle="tab"
                        href="#Inv_d"
                        className="Tab_inv"
                        onClick={() => {
                          this.tabChanged("invoice");
                        }}
                      >
                        Invoice Details
                      </a>
                    </li>
                    {/* <li className=""><a data-toggle="tab" href="#Add_d">Addiotional Details</a></li> */}
                    <li className="" hidden={this.state.isStatusHidden}>
                      <a
                        data-toggle="tab"
                        className="Tab_status"
                        onClick={() => {
                          this.tabChanged("status");
                        }}
                        href="#Stat_d"
                      >
                        Status
                      </a>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <div id="rate" className="tab-pane fade in active">
                      <div className="contcontainer-fulidainer">
                        <div className="subHeader">
                          <p className="ptitle">Request Information</p>
                          <br />
                          <br />
                          <div className="container-fulid">
                            <div className="row">
                              <div className="col-md-7">
                                {this.state.scacVisible && (
                                  <div className="form-group row">
                                    <label
                                      for="inputEmail3"
                                      className="col-sm-3 col-form-label"
                                    >
                                      SCAC / Carrier Code <em>*</em>
                                    </label>
                                    <div
                                      className="col-sm-3"
                                      style={{
                                        padding: "0px",
                                        lineHeight: "34px",
                                      }}
                                    >
                                      <DropDownList
                                        style={{ width: "100%" }}
                                        data={this.state.BindParentCode}
                                        defaultValue="ALL"
                                        dataItemKey="value"
                                        textField="text"
                                        onChange={this.Change_parentScac}
                                        defaultItem={this.parentscac}
                                        value={this.state.ParentScacCode}
                                        filterable={true}
                                        onFilterChange={this.Filter_parentScac}
                                        disabled={this.state.scacDisabled}
                                      />
                                    </div>
                                    <div className="col-sm-4">
                                      <input
                                        type="text"
                                        value={this.state.abbvalue}
                                        disabled={this.state.abbrDisabled}
                                        className="form-control"
                                        readonly
                                      />
                                    </div>
                                  </div>
                                )}
                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    NCRM Reason Code <em>*</em>
                                  </label>
                                  <div className="col-sm-7">
                                    <DropDownList
                                      style={{ width: "100%" }}
                                      data={this.state.BindReasonCode}
                                      defaultValue="ALL"
                                      dataItemKey="value"
                                      textField="text"
                                      onChange={this.Change_reasonCode}
                                      value={this.state.reasoncodeValue}
                                      filterable={true}
                                      onFilterChange={this.Filter_reasonCode}
                                      defaultItem={this.reasonitem}
                                      disabled={this.state.reasonDisabled}
                                    />
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    NCRM Comments
                                  </label>
                                  <div className="col-sm-7">
                                    <textarea
                                      row="3"
                                      className="form-control"
                                      placeholder="Enter comments"
                                      onChange={this.ncrmCommentChanged}
                                      disabled={this.state.ncrmcomtDisabled}
                                      value={this.state.ncrmcommentvalue}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-5">
                                {!this.state.AutzCarrier && (
                                  <div className="form-group row">
                                    <label
                                      for="PurchasingOrg"
                                      className="col-sm-5 col-form-label"
                                    >
                                      Authorizer(s) <em>*</em>
                                    </label>
                                    <div className="col-sm-7">
                                      <MultiSelect
                                        data={this.state.authorization}
                                        disabled={this.state.authorize_disabled}
                                        value={this.state.tobeauthorValue}
                                        dataItemKey="idsid"
                                        textField="name"
                                        onChange={this.handleauthorChange}
                                        filterable={true}
                                        onFilterChange={this.authorizerfilterChange}
                                      ></MultiSelect>
                                    </div>
                                  </div>
                                )}

                                <div className="form-group row">
                                  <label
                                    for="PurchasingOrg"
                                    className="col-sm-5 col-form-label"
                                  >
                                    Requestor Name <em>*</em>
                                  </label>
                                  <div className="col-sm-7">
                                    <input
                                      type="text"
                                      className="form-control"
                                      disabled={this.state.requsername}
                                      value={this.state.userID}
                                      onChange={this.requestNameChanged}
                                    />
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="PurchasingOrg"
                                    className="col-sm-5 col-form-label"
                                  >
                                    Phone Number <em>*</em>
                                  </label>
                                  <div className="col-sm-7">
                                    <input
                                      type="text"
                                      className="form-control"
                                      disabled={this.state.Req_phone_disabled}
                                      placeholder="Enter Phone number"
                                      value={this.state.ResPhonenumber}
                                      onChange={this.getrequestnumber}
                                    />
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="PurchasingOrg"
                                    className="col-sm-5 col-form-label"
                                  >
                                    Email <em>*</em>
                                  </label>
                                  <div className="col-sm-7">
                                    <input
                                      type="text"
                                      className="form-control"
                                      disabled={this.state.requseremail}
                                      value={this.state.userEmail}
                                      onChange={this.Getemailchanged}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="contcontainer-fulidainer">
                            <div className="subHeader">
                              <p className="ptitle">Address Information</p>
                              <div className="container-fulid">
                                <div className="row">
                                  <div className="col-md-7">
                                    <div className="subHeader">
                                      <p className="subptitle">Ship From</p>
                                    </div>

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Location ID
                                      </label>
                                      <div className="col-sm-7">
                                        <input
                                          type="text"
                                          className="form-control"
                                          disabled={this.state.frmlocation}
                                          placeholder="Location ID"
                                          value={this.state.ShipFromLocat}
                                          onChange={
                                            this.ShipFromLocationChanged
                                          }
                                        ></input>
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Company Name <em>*</em>
                                      </label>
                                      <div className="col-sm-7">
                                        <input
                                          type="text"
                                          disabled={
                                            this.state.comp_name_disabled
                                          }
                                          className="form-control"
                                          placeholder="Enter Company Name"
                                          onChange={this.companynameChanged}
                                          value={this.state.ShipFromcompName}
                                        ></input>
                                      </div>
                                    </div>

                                    {/* {this.state.disabled && <div className="form-group row">
                                        <label for="inputPassword3" className="col-sm-3 col-form-label">House No./Street <em>*</em></label>
                                        <div className="col-sm-7">
                                          <input type="text" className="form-control" disabled={this.state.fromhouse_disabled} placeholder="Enter House No./Street" value={this.state.ShipFromhouseStreet} onChange={this.shipfromhousechanged}></input>
                                        </div>
                                      </div>} */}

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Address line <em>*</em>
                                      </label>
                                      <div className="col-sm-7">
                                        <textarea
                                          rows="3"
                                          className="form-control"
                                          disabled={
                                            this.state.Frmaddress_disabled
                                          }
                                          placeholder="Enter Address line"
                                          value={
                                            this.state.shipfromAddressValue
                                          }
                                          onChange={this.AddressLinechanged}
                                        ></textarea>
                                      </div>
                                    </div>

                                    {/*   
  <div className="form-group row">
    <label for="inputPassword3" className="col-sm-3 col-form-label">Address line 2</label>
    <div className="col-sm-7">
    <input type="text" className="form-control" value=""></input>
    </div>
  </div> */}

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-3 col-form-label"
                                      >
                                        City <em>*</em>
                                      </label>
                                      <div className="col-sm-7">
                                        <input
                                          type="text"
                                          className="form-control"
                                          disabled={this.state.frmCity_disabled}
                                          placeholder="Enter City "
                                          value={this.state.shipFromCityValue}
                                          onChange={this.shipfromcityChanged}
                                        ></input>
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Country <em>*</em> / Region <em>*</em>
                                      </label>
                                      <div className="col-sm-4">
                                        <DropDownList
                                          style={{ width: "100%" }}
                                          data={this.state.FromcountryList}
                                          value={this.state.FromCountryValue}
                                          filterable={true}
                                          dataItemKey="value"
                                          textField="text"
                                          disabled={this.state.cntry_Disabled}
                                          defaultItem={this.frmcnt}
                                          onChange={this.FromCountrySelected}
                                          onFilterChange={
                                            this.FilterbyCountryList
                                          }
                                        ></DropDownList>
                                      </div>

                                      <div className="col-sm-3">
                                        <DropDownList
                                          style={{ width: "100%" }}
                                          filterable={true}
                                          data={this.state.FromRegionData}
                                          onChange={this.FromRegionChanged}
                                          value={this.state.fromRegionValue}
                                          disabled={
                                            this.state.frmRegion_disabled
                                          }
                                          defaultItem={this.frmregion}
                                          dataItemKey="value"
                                          onFilterChange={this.FromRegionfilter}
                                          textField="text"
                                        ></DropDownList>
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Port <em>*</em> / Zip Code <em>*</em>
                                      </label>
                                      <div className="col-sm-4">
                                        <DropDownList
                                          style={{ width: "100%" }}
                                          disabled={this.state.frmPort_disabled}
                                          data={this.state.FromPortData}
                                          filterable={true}
                                          onChange={this.FromportChanged}
                                          onFilterChange={this.portfilterList}
                                          dataItemKey="value"
                                          textField="text"
                                          defaultItem={this.frmport}
                                          value={this.state.FromPortValue}
                                        ></DropDownList>
                                      </div>
                                      <div className="col-sm-3">
                                        <input
                                          type="text"
                                          // pattern="[0-9]*"
                                          // max="6"
                                          disabled={
                                            this.state.frmzipCode_disabled
                                          }
                                          className="form-control"
                                          placeholder="Enter Zip code"
                                          value={this.state.FromZipCode}
                                          onChange={this.fromZipCodeChanged}
                                        ></input>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-5">
                                    <div className="subHeader">
                                      <p className="subptitle">
                                        Contact Details
                                      </p>
                                    </div>
                                    {/* <div className="form-group row">
                                        <label for="inputPassword3" className="col-sm-5 col-form-label">BP ID</label>
                                        <div className="col-sm-7">
                                          <input type="text" className="form-control" disabled={this.state.frmbdloc} placeholder="Enter BP ID" value={this.state.FrombpID} onChange={this.bpidchanged}></input>
                                        </div>
                                      </div> */}

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-5 col-form-label"
                                      >
                                        Contact Name <em>*</em>
                                      </label>
                                      <div className="col-sm-7">
                                        <input
                                          type="text"
                                          className="form-control"
                                          disabled={this.state.cntname_disabled}
                                          placeholder="Enter Contact Name"
                                          value={this.state.FromContactName}
                                          onChange={this.FromContactChanged}
                                        ></input>
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-5 col-form-label"
                                      >
                                        Phone Number <em>*</em>
                                      </label>
                                      <div className="col-sm-7">
                                        <input
                                          type="text"
                                          title="Country Code is auto determined; Special Characters not allowed*"
                                          className="form-control"
                                          disabled={
                                            this.state.frmPhone_disabled
                                          }
                                          placeholder="Enter Phone number"
                                          value={this.state.FromShipPhone}
                                          onChange={this.fromShipPhponeChanged}
                                        ></input>
                                        <spn>
                                          <small>
                                            Country Code is auto determined;
                                            Special Characters not allowed*
                                          </small>
                                        </spn>
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-5 col-form-label"
                                      >
                                        Email <em>*</em>
                                      </label>
                                      <div className="col-sm-7">
                                        <input
                                          type="email"
                                          className="form-control"
                                          disabled={
                                            this.state.frmemail_disabled
                                          }
                                          placeholder="Enter Email"
                                          value={this.state.FromShipEmailId}
                                          onChange={this.fromShipemailIdChanged}
                                        ></input>
                                      </div>
                                    </div>

                                    {/* <div className="subHeader" style={{padding:"0px 6px"}}>
            <p className="ptitle">Addtional Information</p>
        </div> */}

                                    {/* <div className="form-group row">
                                        <label for="inputPassword3" className="col-sm-5 col-form-label">Additional Information</label>
                                        <div className="col-sm-7">
                                          <textarea rows="3" className="form-control" disabled={this.state.addInform_disabled} placeholder="Enter Additional Information" onChange={this.FromadditionalInfoChanged} value={this.state.FromadditionInfo}></textarea>
                                        </div>
                                      </div> */}

                                    {/* 
   <div className="form-group row">
    <label for="inputPassword3" className="col-sm-5 col-form-label">Time Zone</label>
    <div className="col-sm-7">
    <input type="text" className="form-control" value=""></input>
    </div>
   </div> */}
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col-md-7">
                                    <div className="subHeader">
                                      <p className="subptitle">Ship To</p>
                                    </div>

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Location ID{" "}
                                      </label>
                                      <div className="col-sm-7">
                                        <input
                                          type="text"
                                          className="form-control"
                                          disabled={this.state.toLocat}
                                          value={this.state.ToLocationId}
                                          onChange={this.TolocationChanged}
                                          placeholder="Location ID"
                                        ></input>
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Company Name <em>*</em>
                                      </label>
                                      <div className="col-sm-7">
                                        <input
                                          type="text"
                                          className="form-control"
                                          disabled={
                                            this.state.Tocompname_disabled
                                          }
                                          placeholder="Enter Company Name"
                                          value={this.state.ToCompanyname}
                                          onChange={this.TocompanyChanged}
                                        ></input>
                                      </div>
                                    </div>

                                    {/* {this.state.disabled && <div className="form-group row">
                                        <label for="inputPassword3" className="col-sm-3 col-form-label">House No./Street <em>*</em></label>
                                        <div className="col-sm-7">
                                          <input type="text" className="form-control" disabled={this.state.toHouse_disabled} placeholder="Enter House No./Street" value={this.state.To_housestreet} onChange={this.ToHouseChanged}></input>
                                        </div>
                                      </div>} */}

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Address line <em>*</em>
                                      </label>
                                      <div className="col-sm-7">
                                        <textarea
                                          rows="3"
                                          className="form-control"
                                          disabled={
                                            this.state.Toaddline_disabled
                                          }
                                          value={this.state.ToAddressline}
                                          onChange={this.ToAddressChanged}
                                          placeholder="Enter Address line"
                                        />
                                      </div>
                                    </div>

                                    {/*   
  <div className="form-group row">
    <label for="inputPassword3" className="col-sm-3 col-form-label">Address line 2</label>
    <div className="col-sm-7">
    <input type="text" className="form-control" value=""></input>
    </div>
  </div> */}

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-3 col-form-label"
                                      >
                                        City <em>*</em>
                                      </label>
                                      <div className="col-sm-7">
                                        <input
                                          type="text"
                                          placeholder="Enter City"
                                          disabled={this.state.toCity_disabled}
                                          className="form-control"
                                          value={this.state.TocityValue}
                                          onChange={this.TocityChanged}
                                        ></input>
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Country <em>*</em> / Region <em>*</em>
                                      </label>
                                      <div className="col-sm-4">
                                        <DropDownList
                                          style={{ width: "100%" }}
                                          disabled={this.state.Tocntry_disabled}
                                          data={this.state.TocountryList}
                                          dataItemKey="value"
                                          textField="text"
                                          value={this.state.toCountryValue}
                                          defaultItem={this.frmcnt}
                                          onChange={this.ToCountryChanged}
                                          onFilterChange={this.ToCountryFilter}
                                          filterable={true}
                                        ></DropDownList>
                                      </div>

                                      <div className="col-sm-3">
                                        <DropDownList
                                          style={{ width: "100%" }}
                                          disabled={
                                            this.state.Toregion_disabled
                                          }
                                          data={this.state.ToRegionData}
                                          dataItemKey="value"
                                          textField="text"
                                          value={this.state.ToRegionValue}
                                          onChange={this.ToRegionChanged}
                                          defaultItem={this.frmregion}
                                          filterable={true}
                                          onFilterChange={
                                            this.ToregionFilterChanged
                                          }
                                        ></DropDownList>
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-3 col-form-label"
                                      >
                                        Port <em>*</em> / Zip Code <em>*</em>
                                      </label>
                                      <div className="col-sm-4">
                                        <DropDownList
                                          style={{ width: "100%" }}
                                          data={this.state.ToPortData}
                                          dataItemKey="value"
                                          onChange={this.ToportChanged}
                                          disabled={this.state.toPort_disabled}
                                          value={this.state.ToportValue}
                                          defaultItem={this.frmport}
                                          filterable={true}
                                          onFilterChange={this.ToportFilter}
                                          textField="text"
                                        ></DropDownList>
                                      </div>

                                      <div className="col-sm-3">
                                        <input
                                          type="text"
                                          placeholder="Enter Zip code"
                                          disabled={this.state.toZip_disabled}
                                          onChange={this.ToZipChanged}
                                          className="form-control"
                                          value={this.state.ToZipvalue}
                                        ></input>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-5">
                                    <div className="subHeader">
                                      <p className="subptitle">
                                        Contact Details
                                      </p>
                                    </div>

                                    {/* <div className="form-group row">
                                        <label for="inputPassword3" className="col-sm-5 col-form-label">BP ID</label>
                                        <div className="col-sm-7">
                                          <input type="text" className="form-control" disabled={this.state.tobdloc} value={this.state.ToBpIdValue} onChange={this.ToBpchanged} placeholder="Enter BP ID"></input>
                                        </div>
                                      </div> */}

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-5 col-form-label"
                                      >
                                        Contact Name <em>*</em>
                                      </label>
                                      <div className="col-sm-7">
                                        <input
                                          type="text"
                                          className="form-control"
                                          disabled={this.state.Tocont_disabled}
                                          placeholder="Enter Contact Name"
                                          value={this.state.ToContactName}
                                          onChange={this.ToContactchanged}
                                        ></input>
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-5 col-form-label"
                                      >
                                        Phone Number <em>*</em>
                                      </label>
                                      <div className="col-sm-7">
                                        <input
                                          type="text"
                                          title="Country Code is auto determined; Special Characters not allowed*"
                                          className="form-control"
                                          disabled={this.state.Tophone_disabled}
                                          placeholder="Enter Phone number"
                                          value={this.state.ToPhoneNumber}
                                          onChange={this.TophoneChanged}
                                        ></input>
                                        <spn>
                                          <small>
                                            Country Code is auto determined;
                                            Special Characters not allowed*
                                          </small>
                                        </spn>
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <label
                                        for="inputPassword3"
                                        className="col-sm-5 col-form-label"
                                      >
                                        Email <em>*</em>
                                      </label>
                                      <div className="col-sm-7">
                                        <input
                                          type="email"
                                          className="form-control"
                                          disabled={this.state.toEmail_disabled}
                                          value={this.state.ToEmail}
                                          onChange={this.toEmailChanged}
                                          placeholder="Enter Email"
                                        ></input>                                        
                                      </div>
                                    </div>
                                    {/* 
   <div className="subHeader" style={{padding:"0px 6px"}}>
      <p className="ptitle">Addtional Information</p>
    </div> */}

                                    {/* <div className="form-group row">
                                        <label for="inputPassword3" className="col-sm-5 col-form-label">Additional Information</label>
                                        <div className="col-sm-7">
                                          <textarea rows="3" className="form-control" disabled={this.state.Toadd_disabled} placeholder="Enter Additional Information" value={this.state.toAdd_info} onChange={this.toaddinfochanged}></textarea>
                                        </div>
                                      </div> */}

                                    {/* <div className="form-group row">
    <label for="inputPassword3" className="col-sm-5 col-form-label">Time Zone</label>
    <div className="col-sm-7">
    <input type="text" className="form-control" value=""></input>
    </div>
   </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="contcontainer-fulidainer">
                            <p className="ptitle">Shipment Information</p>
                            <div className="row">
                              <div className="col-md-7">
                                <div className="subHeader">
                                  <p className="subptitle">Dates</p>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    Requested Pick-up Date<em>*</em>
                                  </label>
                                  <div className="col-sm-7">
                                    <DatePicker
                                      format="MM/dd/yyyy"
                                      formatPlaceholder="formatPattern"
                                      value={this.state.ReqPickupDate}
                                      onChange={this.RqpickupChanged}
                                      disabled={this.state.pickup_disabled}
                                    />
                                    {/* <DateTimePicker 
                                    format="MM/dd/yyyy hh:mm"
                                    formatPlaceholder="formatPattern" 
                                    value={this.state.ReqPickupDate}
                                      onChange={this.RqpickupChanged}
                                      disabled={this.state.pickup_disabled}
                                      defaultValue={RequestPickupDateDefaultValue}
                                      /> */}

                                    <span className="timezone">
                                      {this.state.ShipFromTimeZone}{" "}
                                      {this.state.PortLocationTimeZone}
                                    </span>

                                    {/* <DatePicker format="MM/dd/yyyy" formatPlaceholder="formatPattern" value={this.state.ReqPickupDate} onChange={this.fromdateChanged}></DatePicker> */}
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    Requested Delivery Date<em>*</em>
                                  </label>
                                  <div className="col-sm-7">
                                    <DatePicker
                                      format="MM/dd/yyyy"
                                      formatPlaceholder="formatPattern"
                                      value={this.state.ReqDeliveryDate}
                                      onChange={this.RqdeliveryChanged}
                                      disabled={this.state.delivery_disabled}
                                    />
                                    {/* <DateTimePicker format="MM/dd/yyyy hh:mm"
                                    formatPlaceholder="formatPattern"
                                    value={this.state.ReqDeliveryDate}
                                      onChange={this.RqdeliveryChanged}
                                      disabled={this.state.delivery_disabled} 
                                    > */}

                                    {/* </DateTimePicker> */}
                                    <span className="timezone">
                                      {this.state.ShipToTimeZone}{" "}
                                      {this.state.ToPortLocationTimeZone}
                                    </span>
                                  </div>
                                </div>

                                <div className="subHeader">
                                  <p className="subptitle">
                                    Customs Contact for Outsourced Shipments
                                  </p>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    Broker
                                  </label>
                                  <div className="col-sm-7">
                                    <input
                                      type="text"
                                      placeholder="Enter Broker"
                                      disabled={this.state.broker_disabled}
                                      className="form-control"
                                      value={this.state.brokerValue}
                                      onChange={this.brokerchanged}
                                    />
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    Broker Contact Name
                                  </label>
                                  <div className="col-sm-7">
                                    <input
                                      type="text"
                                      placeholder="Enter Contact name"
                                      disabled={this.state.contName_disabled}
                                      className="form-control"
                                      value={this.state.brokerNameValue}
                                      onChange={this.brokerContactnamechanged}
                                    />{" "}
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    Broker Phone Number
                                  </label>
                                  <div className="col-sm-7">
                                    <input
                                      type="text"
                                      placeholder="Enter Phone number"
                                      disabled={this.state.phone_disabled}
                                      value={this.state.brokerPhonenumbervalue}
                                      onChange={this.brokerphonenumberchanged}
                                      className="form-control"
                                    />
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-3 col-form-label"
                                  >
                                    Broker Email
                                  </label>
                                  <div className="col-sm-7">
                                    <input
                                      type="text"
                                      placeholder="Enter Email"
                                      disabled={this.state.broker_disabled}
                                      value={this.state.brokeremailvalue}
                                      onChange={this.brokeremailchanged}
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-5">
                                <div className="subHeader">
                                  <p className="subptitle">
                                    Service Information
                                  </p>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-5 col-form-label"
                                  >
                                    Service Code <em>*</em>
                                  </label>
                                  <div className="col-sm-7">
                                    <DropDownList
                                      style={{ width: "100%" }}
                                      dataItemKey="value"
                                      data={this.state.ServiceCodeData}
                                      value={this.state.ServiceCodeValue}
                                      filterable={true}
                                      textField="text"
                                      onFilterChange={this.ServiceCodeFilter}
                                      disabled={this.state.service_disabled}
                                      defaultItem={this.svcitm}
                                      onChange={this.Servicecodechanged}
                                    ></DropDownList>
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-5 col-form-label"
                                  >
                                    Commodity Code <em>*</em>
                                  </label>
                                  <div className="col-sm-7">
                                    <DropDownList
                                      style={{ width: "100%" }}
                                      data={this.state.CommodityData}
                                      value={this.state.CommodityValue}
                                      disabled={this.state.comm_disabled}
                                      onChange={this.commChanged}
                                      defaultItem={this.comitm}
                                      dataItemKey="value"
                                      textField="text"
                                    ></DropDownList>
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-5 col-form-label"
                                  >
                                    Transportation Mode <em>*</em>
                                  </label>
                                  <div className="col-sm-7">
                                    <DropDownList
                                      style={{ width: "100%" }}
                                      defaultItem={this.tramitm}
                                      data={this.state.TransportationData}
                                      value={this.state.TransportationValue}
                                      dataItemKey="value"
                                      textField="text"
                                      disabled={this.state.transport_disabled}
                                      onChange={this.transportChanged}
                                    ></DropDownList>
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-5 col-form-label"
                                  >
                                    TPT <em>*</em>
                                  </label>
                                  <div className="col-sm-2">
                                    <input
                                      type="text"
                                      value={this.state.tptValue}
                                      disabled={this.state.tpt_disabled}
                                      onKeyPress={this.handleNumbersEntry}
                                      onChange={this.tptchanged}
                                      className="form-control tptVal"
                                    />
                                    <sup className="ds">Day (s)</sup>
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-5 col-form-label"
                                  >
                                    Incoterms <em>*</em>{" "}
                                  </label>
                                  <div className="col-sm-7">
                                    <DropDownList
                                      style={{ width: "100%" }}
                                      disabled={this.state.inconterms_disabled}
                                      dataItemKey="value"
                                      value={this.state.incotermValue}
                                      filterable={true}
                                      textField="text"
                                      onFilterChange={this.IncoTermFilter}
                                      defaultItem={this.inconitm}
                                      onChange={this.incoTermChanged}
                                      data={this.state.incoTermsData}
                                    ></DropDownList>
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-5 col-form-label"
                                  >
                                    Location <em>*</em>{" "}
                                  </label>
                                  <div className="col-sm-7">
                                    <input
                                      type="text"
                                      className="form-control"
                                      disabled={this.state.location_disabled}
                                      placeholder="Enter Location"
                                      value={this.state.Shiplocationvalue}
                                      onChange={this.shiplocationChanged}
                                    />
                                  </div>
                                </div>

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-5 col-form-label"
                                  >
                                    Intel Reference Number{" "} <em>*</em>
                                  </label>
                                  <div className="col-sm-7">
                                    <textarea
                                      className="form-control"
                                      disabled={this.state.intelrefer_disabled}
                                      placeholder="Enter Intel Reference number"
                                      rows="3"
                                      value={this.state.intelrefnum}
                                      onChange={this.referenceChanged}
                                    ></textarea>
                                  </div>
                                  {/* <label for="inputPassword3" className="col-sm-2 col-form-label">Doc Type </label> */}
                                </div>

                                {!this.state.docTypeStatus && (
                                  <div className="form-group row">
                                    <label
                                      for="inputPassword3"
                                      className="col-sm-5 col-form-label"
                                    ></label>
                                    <div className="col-sm-7" id="doctval">
                                      {" "}
                                      <DropDownList
                                        style={{ width: "100%" }}
                                        data={this.state.DocumentTypeData}
                                        value={this.state.DocTypeValue}
                                        dataItemKey="value"
                                        textField="text"
                                        disabled={this.state.doctype_disabled}
                                        defaultItem={this.ddmentitm}
                                        onChange={this.ServiceDocchanged}
                                      ></DropDownList>
                                    </div>
                                  </div>
                                )}

                                <div className="form-group row">
                                  <label
                                    for="inputPassword3"
                                    className="col-sm-5 col-form-label"
                                  >
                                    Special Instructions{" "}
                                  </label>
                                  <div className="col-sm-7">
                                    <textarea
                                      rows="3"
                                      className="form-control"
                                      disabled={this.state.specialInst_disabled}
                                      placeholder="Enter Special Instruction"
                                      value={this.state.specialinstruct}
                                      onChange={this.specialinstructChanged}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div id="It_d" className="tab-pane fade">
                      <div className="container-fulid">
                        {this.state.FO_Display_Item &&
                          this.state.saveClicked == true && (
                            <div>
                              {
                                <ItemDetail
                                  data={this.state.FO_Display_Item}
                                  props={{
                                    create_request: this.state.isNew,
                                    isEditClicked: this.state.isEditClicked,
                                    tor_Type: this.state.Tor_Type,
                                  }}
                                  ref={this.itemDetailsRef}
                                />
                              }
                            </div>
                          )}
                      </div>
                    </div>

                    {/* <div id="Bid_d" className="tab-pane fade">
                        <div className="container-fulid">
                          <div>
                          {
                              this.state.tor_id && 
                              this.state.currentTab === 'bid' &&
                              <InvoiceBidDetails 
                                props={{
                                  currentComponent: 'bid', 
                                  ParentScacCode: this.state.ParentScacCode,
                                  tor_id: this.state.tor_id,
                                  ReqPickupDate: this.state.ReqPickupDate,
                                  ReqDeliveryDate: this.state.ReqDeliveryDate,
                                  docStatus: this.state.DOCSTATUSForProp, 
                                  vendor_id: this.state.vendor_id,
                                  TransportationValue: this.state.TransportationValue,
                                  tor_Type : this.state.Tor_Type,
                                  // new code 
                                  onBidSaved: () => this.bidSaved(),
                                  invoiceInputs: {                                    
                                    childSCAC: null, 
                                    hawbNumber: null, 
                                    proNumber: null
                                  },
                                  isEditClicked: this.state.isEditClicked,
                                  isCreaedUserDifferentFromLoggedInUserAtStatus10: this.state.EX_HEADER.CREATED_BY !== this.state.logginuserId && this.state.DOCSTATUSForProp === '10',
                                  onEditingFinished: () => this.editingFinished(),
                                  isNewRequest: this.state.isNew
                                }} 
                              />
                            }
                          </div>
                        </div>
                      </div> */}

                    <div id="Bid_d" className="tab-pane fade">
                      <div className="container-fulid">
                        <div>
                          {this.state.Tor_Type !== "ZMSB"
                            ? this.state.tor_id &&
                              this.state.currentTab === "bid" && (
                                <InvoiceBidDetails
                                  props={{
                                    currentComponent: "bid",
                                    ParentScacCode: this.state.ParentScacCode,
                                    tor_id: this.state.tor_id,
                                    ReqPickupDate: this.state.ReqPickupDate,
                                    ReqDeliveryDate: this.state.ReqDeliveryDate,
                                    docStatus: this.state.DOCSTATUSForProp,
                                    vendor_id: this.state.vendor_id,
                                    TransportationValue:
                                      this.state.TransportationValue,
                                    tor_Type: this.state.Tor_Type,
                                    // new code
                                    onBidSaved: () => this.bidSaved(),
                                    invoiceInputs: {
                                      childSCAC: null,
                                      hawbNumber: null,
                                      proNumber: null,
                                    },
                                    isEditClicked: this.state.isEditClicked,
                                    isCreaedUserDifferentFromLoggedInUserAtStatus10:
                                      this.state.EX_HEADER.CREATED_BY !==
                                        this.state.logginuserId &&
                                      this.state.DOCSTATUSForProp === "10",
                                    onEditingFinished: () =>
                                      this.editingFinished(),
                                    isNewRequest: this.state.isNew,
                                    invoiceDetailInputsOnSubmit:
                                      this.state.invoiceDetailInputsOnSubmit,
                                    saveInvoiceDetailInputsOnSubmit:
                                      this.saveInvoiceDetailInputsOnSubmit.bind(
                                        this
                                      ),
                                    rfq_no: "",
                                    timeFromZone: this.state.ShipFromTimeZone,
                                    timeToZone: this.state.ShipToTimeZone,
                                    userRole: this.state.createdByUserRole
                                  }}
                                />
                              )
                            : this.state.currentTab === "bid" && (
                                <TenderingManager
                                  serviceType={this.state.CommodityValue}
                                  shipFrom={
                                    typeof this.state.EX_HEADER ===
                                      "undefined" && !this.state.EX_HEADER
                                      ? ""
                                      : this.state.EX_HEADER.SOURCELOCATION
                                  }
                                  shipTo={
                                    typeof this.state.EX_HEADER ===
                                      "undefined" && !this.state.EX_HEADER
                                      ? ""
                                      : this.state.EX_HEADER.DESTINATIONLOCATION
                                  }
                                  tor_id={this.state.tor_id}
                                  transportationValue={
                                    this.state.TransportationValue
                                  }
                                  vendor_id={this.state.vendor_id}
                                  ReqPickupDate={this.state.ReqPickupDate}
                                  ReqDeliveryDate={this.state.ReqDeliveryDate}
                                  docStatus={this.state.DOCSTATUSForProp}
                                  TransportationValue={
                                    this.state.TransportationValue
                                  }
                                  ref={this.tenderingManagerRef}
                                  timeFromZone={this.state.ShipFromTimeZone}
                                  timeToZone={this.state.ShipToTimeZone}
                                />
                              )}
                        </div>
                      </div>
                    </div>

                    <div id="Inv_d" className="tab-pane fade">
                      <div className="container-fulid">
                        {this.state.tor_id &&
                          this.state.currentTab === "invoice" && (
                            <InvoiceBidDetails
                              props={{
                                currentComponent: "invoice",
                                ParentScacCode: this.state.ParentScacCode,
                                tor_id: this.state.tor_id,
                                ReqPickupDate: this.state.ReqPickupDate,
                                ReqDeliveryDate: this.state.ReqDeliveryDate,
                                docStatus: this.state.DOCSTATUSForProp,
                                vendor_id: this.state.vendor_id,
                                TransportationValue:
                                  this.state.TransportationValue,
                                tor_Type: this.state.Tor_Type,
                                // new code
                                onBidSaved: () => this.bidSaved(),
                                invoiceInputs: {
                                  childSCAC:
                                    this.state.DOCSTATUSForProp > "70" ||
                                    (this.state.Tor_Type === "ZEXC" &&
                                      this.state.DOCSTATUSForProp >= "10")
                                      ? this.state.EX_HEADER["TSPEXEC_SCAC"]
                                      : null,
                                  // hawbNumber: this.state.DOCSTATUSForProp >= "71" ?  this.state.EX_DOCREF[1]['BTD_ID'] : null,
                                  // proNumber: this.state.DOCSTATUSForProp >= "71" ?  this.state.EX_DOCREF[1]['BTD_ID'] : null
                                  hawbNumber:
                                    this.state.DOCSTATUSForProp > "70" ||
                                    (this.state.Tor_Type === "ZEXC" &&
                                      this.state.DOCSTATUSForProp >= "10")
                                      ? this.state.HawbNumber
                                      : null,
                                  proNumber:
                                    this.state.DOCSTATUSForProp > "70" ||
                                    (this.state.Tor_Type === "ZEXC" &&
                                      this.state.DOCSTATUSForProp >= "10")
                                      ? this.state.ProNumber
                                      : null,
                                },
                                isEditClicked: this.state.isEditClicked,
                                isCreaedUserDifferentFromLoggedInUserAtStatus10:
                                  this.state.EX_HEADER.CREATED_BY !==
                                    this.state.logginuserId &&
                                  this.state.DOCSTATUSForProp === "10",
                                onEditingFinished: () => this.editingFinished(),
                                isNewRequest: this.state.isNew,
                                invoiceDetailInputsOnSubmit:
                                  this.state.invoiceDetailInputsOnSubmit,
                                saveInvoiceDetailInputsOnSubmit:
                                  this.saveInvoiceDetailInputsOnSubmit.bind(
                                    this
                                  ),
                                rfq_no: "",
                                timeFromZone: this.state.ShipFromTimeZone,
                                timeToZone: this.state.ShipToTimeZone,
                                userRole: this.state.createdByUserRole
                              }}
                            />
                          )}
                      </div>
                    </div>

                    <div id="Add_d" className="tab-pane fade">
                      <div className="container-fulid">
                        <h1>Additional Details</h1>
                      </div>
                    </div>

                    {/* <div id="Appr_d" className="tab-pane fade">
                        <div className="container-fulid">
                          <h1>Approval Details</h1>
                        </div>
                      </div> */}

                    <div id="Stat_d" className="tab-pane fade">
                      <div className="">
                        {this.state.tor_id &&
                          this.state.currentTab === "status" && (
                            <div id="sthis">
                              <StatusHistorys foData={this.state} />
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
    </BlockUi>
      </div>
    );
  }
}

$(document).ready(function () {
  // const dd=new Date();
  // document.getElementById("ddtime").innerHTML=dd;

  $("#customBox ul li").on("click", function () {
    $("#grid").show();
    $("#customBox ul li").removeClass("active");
    $(this).addClass("active");
    // if($("#customBox ul li").find().text("Rate Extension")){
    //     $("#grid").hide();
    // }
  });
});

export default withRouter(IntelShipRequest);
